function isLastChar(index, input) {
  return index === input.length - 1;
}

function onlyNumbers(input) {
  return String(input).replace(/[^\d]/g, '');
}

function generateChecksum(base, weight) {
  var digits = onlyNumbers(base);
  var weights = typeof weight === 'number' ? Array(digits.length).fill(0).map(function (_, i) {
    return weight - i;
  }) : weight;
  return digits.split('').reduce(function (acc, digit, i) {
    return acc + parseInt(digit, 10) * weights[i];
  }, 0);
}

function generateRandomNumber(length) {
  return Array(length).fill(1).reduce(function (acc, number) {
    return "" + acc + Math.random().toString().substr(2, number);
  }, '');
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var STATES_DATA = {
  AC: {
    code: '2',
    areaCodes: [68],
    ieLength: 13,
    name: 'Acre'
  },
  AL: {
    code: '4',
    areaCodes: [82],
    ieLength: 9,
    name: 'Alagoas'
  },
  AP: {
    code: '2',
    areaCodes: [96],
    ieLength: 9,
    name: 'Amapá'
  },
  AM: {
    code: '2',
    areaCodes: [92, 97],
    ieLength: 9,
    name: 'Amazonas'
  },
  BA: {
    code: '5',
    areaCodes: [71, 73, 74, 75, 77],
    ieLength: [8, 9],
    name: 'Bahia'
  },
  CE: {
    code: '3',
    areaCodes: [85, 88],
    ieLength: 9,
    name: 'Ceará'
  },
  DF: {
    code: '1',
    areaCodes: [61],
    ieLength: 13,
    name: 'Distrito Federal'
  },
  ES: {
    code: '7',
    areaCodes: [27, 28],
    ieLength: 9,
    name: 'Espírito Santo'
  },
  GO: {
    code: '1',
    areaCodes: [62, 64],
    ieLength: 9,
    name: 'Goiás'
  },
  MA: {
    code: '3',
    areaCodes: [98, 99],
    ieLength: 9,
    name: 'Maranhão'
  },
  MG: {
    code: '6',
    areaCodes: [31, 32, 33, 34, 35, 37, 38],
    ieLength: 13,
    name: 'Minas Gerais'
  },
  MT: {
    code: '1',
    areaCodes: [65, 66],
    ieLength: 11,
    name: 'Mato Grosso'
  },
  MS: {
    code: '1',
    areaCodes: [67],
    ieLength: 9,
    name: 'Mato Grosso do Sul'
  },
  PA: {
    code: '2',
    areaCodes: [91, 93, 94],
    ieLength: 9,
    name: 'Pará'
  },
  PB: {
    code: '4',
    areaCodes: [83],
    ieLength: 9,
    name: 'Paraíba'
  },
  PE: {
    code: '4',
    areaCodes: [81, 87],
    ieLength: 9,
    name: 'Pernambuco'
  },
  PI: {
    code: '3',
    areaCodes: [86, 89],
    ieLength: 9,
    name: 'Piauí'
  },
  PR: {
    code: '9',
    areaCodes: [41, 42, 43, 44, 45, 46],
    ieLength: 10,
    name: 'Paraná'
  },
  RJ: {
    code: '7',
    areaCodes: [21, 22, 24],
    ieLength: 8,
    name: 'Rio de Janeiro'
  },
  RN: {
    code: '4',
    areaCodes: [84],
    ieLength: [9, 10],
    name: 'Rio Grande do Norte'
  },
  RO: {
    code: '2',
    areaCodes: [69],
    ieLength: 14,
    name: 'Rondônia'
  },
  RS: {
    code: '0',
    areaCodes: [51, 53, 54, 55],
    ieLength: 10,
    name: 'Rio Grande do Sul'
  },
  RR: {
    code: '2',
    areaCodes: [95],
    ieLength: 9,
    name: 'Roraima'
  },
  SC: {
    code: '9',
    areaCodes: [47, 48, 49],
    ieLength: 9,
    name: 'Santa Catarina'
  },
  SE: {
    code: '5',
    areaCodes: [79],
    ieLength: 9,
    name: 'Sergipe'
  },
  SP: {
    code: '8',
    areaCodes: [11, 12, 13, 14, 15, 16, 17, 18, 19],
    ieLength: 12,
    name: 'São Paulo'
  },
  TO: {
    code: '1',
    areaCodes: [63],
    ieLength: [9, 11],
    name: 'Tocantins'
  }
};
var STATES = /*#__PURE__*/Object.keys(STATES_DATA);

var Validator = /*#__PURE__*/function () {
  function Validator() {}

  var _proto = Validator.prototype;

  _proto.isValid = function isValid(ie) {
    return this.checkLength(ie) && this.itStartsWith(ie) && this.calcIe(ie);
  };

  return Validator;
}();

var AC = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(AC, _Validator);

  function AC() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = AC.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.AC.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return ie.substr(0, 2) === '01';
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigits(ie);
  };

  _proto.calcDigits = function calcDigits(inscricaoEstadual) {
    var length = inscricaoEstadual.length;
    var body = inscricaoEstadual.substr(0, length - 2);
    var fDig = this.calcDigit(body);
    var sDig = this.calcDigit(body + fDig.toString());
    var pos2dig = inscricaoEstadual.length - 1;
    var pos1dig = inscricaoEstadual.length - 2;
    return parseInt(inscricaoEstadual[pos1dig], 10) === fDig && parseInt(inscricaoEstadual[pos2dig], 10) === sDig;
  };

  _proto.calcDigit = function calcDigit(body) {
    var weight = body.length - 7;
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;

      if (weight === 1) {
        weight = 9;
      }
    });
    var mod = 11;
    var rest = sum % mod;
    var dig = mod - rest;

    if (dig >= 10) {
      dig = 0;
    }

    return dig;
  };

  return AC;
}(Validator);

var AL = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(AL, _Validator);

  function AL() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = AL.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.AL.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return ie.substr(0, 2) === '24';
  };

  _proto.calcIe = function calcIe(ie) {
    return this.digitCalc(ie);
  };

  _proto.digitCalc = function digitCalc(ie) {
    var weight = 9;
    var position = 8;
    var sum = 0;

    for (var i = 0; i < position; i++) {
      sum += parseInt(ie.charAt(i), 10) * weight;
      weight--;
    }

    var product = sum * 10;
    var digit = product - Math.floor(product / 11) * 11;

    if (digit >= 10) {
      digit = 0;
    }

    return digit === parseInt(ie.charAt(position), 10);
  };

  return AL;
}(Validator);

var AP = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(AP, _Validator);

  function AP() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = AP.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.AP.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return ie.substr(0, 2) === '03';
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = length;
    var body = ie.substr(0, position);
    var bodyInt = parseInt(body, 10);
    var p = 0;
    var d = 0;

    if (3000001 <= bodyInt && bodyInt <= 3017000) {
      p = 5;
      d = 0;
    } else if (bodyInt >= 3017001 && bodyInt <= 3019022) {
      p = 9;
      d = 1;
    }

    var sum = p;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;
    });
    var dig = 11 - sum % 11;

    if (dig === 10) {
      dig = 0;
    }

    if (dig === 11) {
      dig = d;
    }

    return dig === parseInt(ie.charAt(position), 10);
  };

  return AP;
}(Validator);

var AM = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(AM, _Validator);

  function AM() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = AM.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.AM.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = length;
    var body = ie.substr(0, position);
    var sum = 0;
    var dig = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;
    });

    if (sum < 11) {
      dig = 11 - sum;
    } else {
      var rest = sum % 11;
      dig = 11 - rest;

      if (dig >= 10) {
        dig = 0;
      }
    }

    return dig === parseInt(ie.charAt(position), 10);
  };

  return AM;
}(Validator);

var BA = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(BA, _Validator);

  function BA() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = BA.prototype;

  _proto.checkLength = function checkLength(ie) {
    return STATES_DATA.BA.ieLength.includes(ie.length);
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigits(ie);
  };

  _proto.calcDigits = function calcDigits(ie) {
    var length = ie.length;
    var body = ie.substr(0, length - 2);
    var mod = this.getModule(ie);
    var secondDig = this.calcDigit(body, mod);
    var firstDig = this.calcDigit(body + secondDig, mod);
    var posSecondDig = length - 1;
    var posFirstDig = length - 2;
    var ieAtFirstPos = parseInt(ie.charAt(posFirstDig), 10);
    var ieAtSecondPos = parseInt(ie.charAt(posSecondDig), 10);
    return ieAtFirstPos === firstDig && ieAtSecondPos === secondDig;
  };

  _proto.getModule = function getModule(ie) {
    var pos = 0;

    if (ie.length === 9) {
      pos = 1;
    }

    var charAt = parseInt(ie.substr(pos, 1), 10);
    var arr = [0, 1, 2, 3, 4, 5, 8];

    if (arr.indexOf(charAt) >= 0) {
      return 10;
    }

    return 11;
  };

  _proto.calcDigit = function calcDigit(body, mod) {
    var weight = body.length + 1;
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;
    });
    var rest = sum % mod;
    var dig = mod - rest;

    if (dig >= 10) {
      dig = 0;
    }

    return dig;
  };

  return BA;
}(Validator);

var CE = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(CE, _Validator);

  function CE() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = CE.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.CE.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = length;
    var body = ie.substr(0, position);
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;
    });
    var rest = sum % 11;
    var dig = 11 - rest;

    if (dig >= 10) {
      dig = 0;
    }

    return dig === parseInt(ie.charAt(position), 10);
  };

  return CE;
}(Validator);

var DF = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(DF, _Validator);

  function DF() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = DF.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.DF.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return ie.substr(0, 2) === '07';
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigits(ie);
  };

  _proto.calcDigits = function calcDigits(ie) {
    var length = ie.length;
    var body = ie.substr(0, length - 2);
    var firstDig = this.calcDigit(body);
    var secondDig = this.calcDigit(body + firstDig);
    var posSecondDig = length - 1;
    var posFirstDig = length - 2;
    var ieAtFirstPos = parseInt(ie.charAt(posFirstDig), 10);
    var ieAtSecondPos = parseInt(ie.charAt(posSecondDig), 10);
    return ieAtFirstPos === firstDig && ieAtSecondPos === secondDig;
  };

  _proto.calcDigit = function calcDigit(body) {
    var weight = body.length - 7;
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;

      if (weight === 1) {
        weight = 9;
      }
    });
    var mod = 11;
    var rest = sum % mod;
    var dig = mod - rest;

    if (dig >= 10) {
      dig = 0;
    }

    return dig;
  };

  return DF;
}(Validator);

var ES = /*#__PURE__*/function (_CE) {
  _inheritsLoose(ES, _CE);

  function ES() {
    return _CE.apply(this, arguments) || this;
  }

  return ES;
}(CE);

var GO = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(GO, _Validator);

  function GO() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = GO.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.GO.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    var beginWith = ['10', '11', '12'];
    var begin = ie.substr(0, 2);
    return beginWith.indexOf(begin) >= 0;
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = length;
    var body = ie.substr(0, position);
    var bodyInt = parseInt(body, 10);
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;
    });
    var rest = sum % 11;
    var dig = 11 - rest;

    if (dig >= 10) {
      if (dig === 11 && 10103105 <= bodyInt && bodyInt <= 10119997) {
        dig = 1;
      } else {
        dig = 0;
      }
    }

    return dig === parseInt(ie.charAt(position), 10);
  };

  return GO;
}(Validator);

var MA = /*#__PURE__*/function (_CE) {
  _inheritsLoose(MA, _CE);

  function MA() {
    return _CE.apply(this, arguments) || this;
  }

  var _proto = MA.prototype;

  _proto.itStartsWith = function itStartsWith(ie) {
    return ie.substr(0, 2) === '12';
  };

  return MA;
}(CE);

var MT = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(MT, _Validator);

  function MT() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = MT.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.MT.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = 3;
    var body = ie.substr(0, position);
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;

      if (weight === 1) {
        weight = 9;
      }
    });
    var rest = sum % 11;
    var dig = 11 - rest;

    if (dig >= 10) {
      dig = 0;
    }

    return dig === parseInt(ie.charAt(position), 10);
  };

  return MT;
}(Validator);

var MS = /*#__PURE__*/function (_CE) {
  _inheritsLoose(MS, _CE);

  function MS() {
    return _CE.apply(this, arguments) || this;
  }

  var _proto = MS.prototype;

  _proto.itStartsWith = function itStartsWith(ie) {
    return ie.substr(0, 2) === '28';
  };

  return MS;
}(CE);

var MG = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(MG, _Validator);

  function MG() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = MG.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.MG.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var posFirstDigit = length - 2;
    var posSecondDigit = length - 1;
    var body = ie.substring(0, 11);
    var firstDigit = this.calcFirstDigit(body);
    var secondDigit = this.calcSecondDigit(body + firstDigit);
    var digitAtFirstDigit = parseInt(ie.charAt(posFirstDigit), 10);
    var digitAtSecondDigit = parseInt(ie.charAt(posSecondDigit), 10);
    return firstDigit === digitAtFirstDigit && secondDigit === digitAtSecondDigit;
  };

  _proto.calcFirstDigit = function calcFirstDigit(ie) {
    var body = ie.slice(0, 3) + 0 + ie.slice(3);
    var concat = '';
    body.split('').forEach(function (item, index) {
      var weight = (index + 3) % 2 === 0 ? 2 : 1;
      concat += parseInt(item, 10) * weight;
    });
    var sum = 0;
    concat.split('').forEach(function (item) {
      sum += parseInt(item, 10);
    });
    var sumString = sum.toString();
    var length = sumString.length;
    var lastChar = sumString.substr(length - 1, 1);
    var lastCharInt = parseInt(lastChar, 10);
    return lastCharInt === 0 ? 0 : 10 - lastCharInt;
  };

  _proto.calcSecondDigit = function calcSecondDigit(body) {
    var weight = 3;
    var sum = 0;
    body.split('').forEach(function (item) {
      sum += parseInt(item, 10) * weight;
      weight--;

      if (weight === 1) {
        weight = 11;
      }
    });
    var rest = sum % 11;
    var digit = 11 - rest;

    if (digit >= 10) {
      digit = 0;
    }

    return digit;
  };

  return MG;
}(Validator);

var PA = /*#__PURE__*/function (_CE) {
  _inheritsLoose(PA, _CE);

  function PA() {
    return _CE.apply(this, arguments) || this;
  }

  var _proto = PA.prototype;

  _proto.itStartsWith = function itStartsWith(ie) {
    return ie.substr(0, 2) === '15';
  };

  return PA;
}(CE);

var PB = /*#__PURE__*/function (_CE) {
  _inheritsLoose(PB, _CE);

  function PB() {
    return _CE.apply(this, arguments) || this;
  }

  return PB;
}(CE);

var PR = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(PR, _Validator);

  function PR() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = PR.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.PR.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigits(ie);
  };

  _proto.calcDigits = function calcDigits(ie) {
    var length = ie.length;
    var body = ie.substr(0, length - 2);
    var firstDig = this.calcDigit(body);
    var secondDig = this.calcDigit(body + firstDig);
    var posSecondDig = length - 1;
    var posFirstDig = length - 2;
    var ieAtFirstPos = parseInt(ie.charAt(posFirstDig), 10);
    var ieAtSecondPos = parseInt(ie.charAt(posSecondDig), 10);
    return ieAtFirstPos === firstDig && ieAtSecondPos === secondDig;
  };

  _proto.calcDigit = function calcDigit(body) {
    var weight = body.length - 5;
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;

      if (weight === 1) {
        weight = 7;
      }
    });
    var mod = 11;
    var rest = sum % mod;
    var dig = mod - rest;

    if (dig >= 10) {
      dig = 0;
    }

    return dig;
  };

  return PR;
}(Validator);

var PE = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(PE, _Validator);

  function PE() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = PE.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.PE.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigits(ie);
  };

  _proto.calcDigits = function calcDigits(ie) {
    var length = ie.length;
    var body = ie.substr(0, length - 2);
    var firstDig = this.calcDigit(body);
    var secondDig = this.calcDigit(body + firstDig);
    var posSecondDig = length - 1;
    var posFirstDig = length - 2;
    var ieAtFirstPos = parseInt(ie.charAt(posFirstDig), 10);
    var ieAtSecondPos = parseInt(ie.charAt(posSecondDig), 10);
    return ieAtFirstPos === firstDig && ieAtSecondPos === secondDig;
  };

  _proto.calcDigit = function calcDigit(body) {
    var weight = body.length + 1;
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;
    });
    var mod = 11;
    var rest = sum % mod;
    var dig = mod - rest;

    if (dig >= 10) {
      dig = 0;
    }

    return dig;
  };

  return PE;
}(Validator);

var PI = /*#__PURE__*/function (_CE) {
  _inheritsLoose(PI, _CE);

  function PI() {
    return _CE.apply(this, arguments) || this;
  }

  return PI;
}(CE);

var RJ = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(RJ, _Validator);

  function RJ() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = RJ.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.RJ.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = 2;
    var body = ie.substr(0, position);
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;

      if (weight === 1) {
        weight = 7;
      }
    });
    var rest = sum % 11;
    var dig = 11 - rest;

    if (dig >= 10) {
      dig = 0;
    }

    return dig === parseInt(ie.charAt(position), 10);
  };

  return RJ;
}(Validator);

var RN = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(RN, _Validator);

  function RN() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = RN.prototype;

  _proto.checkLength = function checkLength(ie) {
    return STATES_DATA.RN.ieLength.includes(ie.length);
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return ie.substr(0, 2) === '20';
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = length;
    var body = ie.substr(0, position);
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;
    });
    var rest = sum % 11;
    var dig = 11 - rest;

    if (dig >= 10) {
      dig = 0;
    }

    return dig === parseInt(ie.charAt(position), 10);
  };

  return RN;
}(Validator);

var RS = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(RS, _Validator);

  function RS() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = RS.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.RS.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = 2;
    var body = ie.substr(0, position);
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;

      if (weight === 1) {
        weight = 9;
      }
    });
    var rest = sum % 11;
    var dig = 11 - rest;

    if (dig >= 10) {
      dig = 0;
    }

    return dig === parseInt(ie.charAt(position), 10);
  };

  return RS;
}(Validator);

var RO = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(RO, _Validator);

  function RO() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = RO.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.RO.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = 6;
    var body = ie.substr(0, position);
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;

      if (weight === 1) {
        weight = 9;
      }
    });
    var rest = sum % 11;
    var dig = 11 - rest;

    if (dig >= 10) {
      dig -= 10;
    }

    return dig === parseInt(ie.charAt(position), 10);
  };

  return RO;
}(Validator);

var RR = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(RR, _Validator);

  function RR() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = RR.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.RR.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return ie.substr(0, 2) === '24';
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = 1;
    var body = ie.substr(0, position);
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight++;
    });
    var dig = sum % 9;
    return dig === parseInt(ie.charAt(position), 10);
  };

  return RR;
}(Validator);

var SC = /*#__PURE__*/function (_CE) {
  _inheritsLoose(SC, _CE);

  function SC() {
    return _CE.apply(this, arguments) || this;
  }

  return SC;
}(CE);

var SP = /*#__PURE__*/function (_Validator) {
  _inheritsLoose(SP, _Validator);

  function SP() {
    return _Validator.apply(this, arguments) || this;
  }

  var _proto = SP.prototype;

  _proto.checkLength = function checkLength(ie) {
    return ie.length === STATES_DATA.SP.ieLength;
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.calcDigit(ie);
  };

  _proto.calcDigit = function calcDigit(ie) {
    var length = ie.length;
    var positionFirstDigit = length - 4;
    var positionSecondDigit = length - 1;
    var firstDigit = this.calcFirstDigit(ie);
    var secondDigit = this.calcSecondDigit(ie);
    var ieAtFirstPos = parseInt(ie.charAt(positionFirstDigit), 10);
    var ieAtSecondPos = parseInt(ie.charAt(positionSecondDigit), 10);
    return firstDigit === ieAtFirstPos && secondDigit === ieAtSecondPos;
  };

  _proto.calcFirstDigit = function calcFirstDigit(ie) {
    var body = ie.substr(0, 8);
    var weight = [1, 3, 4, 5, 6, 7, 8, 10];
    var sum = 0;
    body.split('').forEach(function (digit, index) {
      sum += parseInt(digit, 10) * weight[index];
    });
    var dig = sum % 11;
    var digit = dig.toString();
    return parseInt(digit.substr(digit.length - 1, 1), 10);
  };

  _proto.calcSecondDigit = function calcSecondDigit(ie) {
    var body = ie.substr(0, 11);
    var weight = 3;
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;

      if (weight === 1) {
        weight = 10;
      }
    });
    var dig = sum % 11;
    var digit = dig.toString();
    return parseInt(digit.substr(digit.length - 1, 1), 10);
  };

  return SP;
}(Validator);

var SE = /*#__PURE__*/function (_CE) {
  _inheritsLoose(SE, _CE);

  function SE() {
    return _CE.apply(this, arguments) || this;
  }

  return SE;
}(CE);

var TO = /*#__PURE__*/function (_CE) {
  _inheritsLoose(TO, _CE);

  function TO() {
    return _CE.apply(this, arguments) || this;
  }

  var _proto = TO.prototype;

  _proto.checkLength = function checkLength(ie) {
    return STATES_DATA.TO.ieLength.includes(ie.length);
  };

  _proto.itStartsWith = function itStartsWith(ie) {
    return Boolean(ie);
  };

  _proto.calcIe = function calcIe(ie) {
    return this.checkOld(ie) || this.checkNew(ie);
  };

  _proto.checkOld = function checkOld(ie) {
    var body = ie.slice(0, 2) + ie.slice(4);
    return this.oldStartsWith(ie) && this.calcOld(body);
  };

  _proto.oldStartsWith = function oldStartsWith(ie) {
    var beginWith = ['01', '02', '03', '99'];
    var begin = ie.substr(2, 2);
    return beginWith.indexOf(begin) >= 0;
  };

  _proto.calcOld = function calcOld(ie) {
    return this.calcDigit(ie);
  };

  _proto.checkNew = function checkNew(ie) {
    return this.calcNew(ie);
  };

  _proto.calcNew = function calcNew(ie) {
    var length = ie.length;
    var position = length - 1;
    var weight = 9;
    var body = ie.substr(0, position);
    var sum = 0;
    body.split('').forEach(function (digit) {
      sum += parseInt(digit, 10) * weight;
      weight--;
    });
    var rest = sum % 11;
    var dig = 11 - rest;

    if (rest < 2) {
      dig = 0;
    }

    return dig === parseInt(ie.charAt(position), 10);
  };

  return TO;
}(CE);

var STATE = {
  AC: AC,
  AL: AL,
  AP: AP,
  AM: AM,
  BA: BA,
  CE: CE,
  DF: DF,
  ES: ES,
  GO: GO,
  MA: MA,
  MT: MT,
  MS: MS,
  MG: MG,
  PA: PA,
  PB: PB,
  PR: PR,
  PE: PE,
  PI: PI,
  RJ: RJ,
  RN: RN,
  RS: RS,
  RO: RO,
  RR: RR,
  SC: SC,
  SP: SP,
  SE: SE,
  TO: TO
};
function isValid(uf, inscricaoEstadual) {
  var digits = onlyNumbers(inscricaoEstadual);
  var state = new STATE[uf]();
  return state.isValid(digits);
}

var LENGTH = 11;
var WEIGHTS = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
var RESERVED_NUMBERS = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];

function isValidLength(pis) {
  return pis.length === LENGTH;
}

function isReservedNumber(pis) {
  return RESERVED_NUMBERS.indexOf(pis) >= 0;
}

function hasOnlyNumbers(pis) {
  return !!pis.match(/^[0-9]+$/);
}

function removeSeparators(pis) {
  return pis.replace(/[ ().,*-]/g, '');
}

function isValid$1(pis) {
  if (!pis || typeof pis !== 'string') return false;
  var numeric = removeSeparators(pis);
  if (!isValidLength(numeric) || isReservedNumber(numeric) || !hasOnlyNumbers(numeric)) return false;
  var weightedChecksum = generateChecksum(numeric.substr(0, numeric.length - 1), WEIGHTS);
  var verifyingDigit = +numeric.charAt(numeric.length - 1);
  var calculatedDigit = 11 - weightedChecksum % 11;
  return calculatedDigit === verifyingDigit || calculatedDigit === 10 && verifyingDigit === 0 || calculatedDigit === 11 && verifyingDigit === 0;
}

var VALID_AREA_CODES = /*#__PURE__*/Object.keys(STATES_DATA).reduce(function (acc, state) {
  return acc.concat(STATES_DATA[state].areaCodes);
}, []);
var PHONE_MIN_LENGTH = 10;
var PHONE_MAX_LENGTH = 11;
var MOBILE_VALID_FIRST_NUMBERS = [6, 7, 8, 9];
var LANDLINE_VALID_FIRST_NUMBERS = [2, 3, 4, 5];
function isValidDDD(phone) {
  return VALID_AREA_CODES.includes(Number(phone.substr(0, 2)));
}
function isValidMobilePhoneLength(phone) {
  return phone.length === PHONE_MAX_LENGTH;
}
function isValidLandlinePhoneLength(phone) {
  return phone.length >= PHONE_MIN_LENGTH && phone.length < PHONE_MAX_LENGTH;
}
function isValidLength$1(phone) {
  return isValidLandlinePhoneLength(phone) || isValidMobilePhoneLength(phone);
}
function isValidMobilePhoneFirstNumber(phone) {
  return MOBILE_VALID_FIRST_NUMBERS.includes(Number(phone.charAt(2)));
}
function isValidLandlinePhoneFirstNumber(phone) {
  return LANDLINE_VALID_FIRST_NUMBERS.includes(Number(phone.charAt(2)));
}
function isValidFirstNumber(phone) {
  return phone.length === PHONE_MIN_LENGTH ? isValidLandlinePhoneFirstNumber(phone) : isValidMobilePhoneFirstNumber(phone);
}

function parsePhoneDigits(phone) {
  return {
    isValidDigits: !!phone && typeof phone === 'string',
    digits: onlyNumbers(phone)
  };
}

function isValidMobilePhone(phone) {
  var _parsePhoneDigits = parsePhoneDigits(phone),
      isValidDigits = _parsePhoneDigits.isValidDigits,
      digits = _parsePhoneDigits.digits;

  if (!isValidDigits) return false;
  return isValidMobilePhoneLength(digits) && isValidMobilePhoneFirstNumber(digits) && isValidDDD(digits);
}
function isValidLandlinePhone(phone) {
  var _parsePhoneDigits2 = parsePhoneDigits(phone),
      isValidDigits = _parsePhoneDigits2.isValidDigits,
      digits = _parsePhoneDigits2.digits;

  if (!isValidDigits) return false;
  return isValidLandlinePhoneLength(digits) && isValidLandlinePhoneFirstNumber(digits) && isValidDDD(digits);
}
function isValid$2(phone) {
  var _parsePhoneDigits3 = parsePhoneDigits(phone),
      isValidDigits = _parsePhoneDigits3.isValidDigits,
      digits = _parsePhoneDigits3.digits;

  if (!isValidDigits) return false;
  return isValidLength$1(digits) && isValidFirstNumber(digits) && isValidDDD(digits);
}

var MAX_RECIPIENT_LENGTH = 64;
var MAX_DOMAIN_LENGTH = 253;
var MAX_EMAIL_LENGTH = MAX_RECIPIENT_LENGTH + 1 + MAX_DOMAIN_LENGTH;
var validEmailRegex = /^([!#$%&'*+\-/=?^_`{|}~]{0,1}([a-zA-Z0-9][!#$%&'*+\-/=?^_`{|}~.]{0,1})+)@(([a-zA-Z0-9][-.]{0,1})+)([.]{1}[a-zA-Z0-9]+)$/;

var stringIsBiggerThan = function stringIsBiggerThan(len) {
  for (var _len = arguments.length, strs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    strs[_key - 1] = arguments[_key];
  }

  return strs.reduce(function (length, s) {
    return length + s.length;
  }, 0) > len;
};

function isValid$3(email) {
  if (!email || typeof email !== 'string') return false;
  if (stringIsBiggerThan(MAX_EMAIL_LENGTH, email)) return false;
  var matchedEmail = validEmailRegex.exec(email);
  if (!matchedEmail) return false;
  var recipient = matchedEmail[1],
      domain = matchedEmail[3],
      topLevelDomain = matchedEmail[5];
  if (stringIsBiggerThan(MAX_RECIPIENT_LENGTH, recipient)) return false;
  if (stringIsBiggerThan(MAX_DOMAIN_LENGTH, domain, topLevelDomain)) return false;
  return true;
}

var validMercosulLicensePlateRegex = /^[a-z]{3}[0-9]{1}[a-z]{1}[0-9]{2}$/i;
var validBrazilianLicensePlateRegex = /^[a-z]{3}-?[0-9]{4}$/i;
function isValid$4(licensePlate) {
  if (!licensePlate || typeof licensePlate !== 'string') return false;
  return validMercosulLicensePlateRegex.test(licensePlate) || validBrazilianLicensePlateRegex.test(licensePlate);
}

var LENGTH$1 = 20;
var DOT_INDEXES = [8, 12, 15];
var HYPHEN_INDEXES = [6];
function format(processoJuridico) {
  var digits = onlyNumbers(processoJuridico);
  return digits.slice(0, LENGTH$1).split('').reduce(function (acc, digit, index) {
    var result = "" + acc + digit;

    if (!isLastChar(index, processoJuridico)) {
      if (DOT_INDEXES.includes(index)) return result + ".";
      if (HYPHEN_INDEXES.includes(index)) return result + "-";
    }

    return result;
  }, '');
}

var LENGTH$2 = 8;
var HYPHEN_INDEXES$1 = [4];

function isValidLength$2(cep) {
  return cep.length === LENGTH$2;
}

function format$1(cep) {
  var digits = onlyNumbers(cep);
  return digits.slice(0, LENGTH$2).split('').reduce(function (acc, digit, i) {
    var result = "" + acc + digit;

    if (!isLastChar(i, digits)) {
      if (HYPHEN_INDEXES$1.indexOf(i) >= 0) return result + "-";
    }

    return result;
  }, '');
}
function isValid$5(cep) {
  if (!cep || typeof cep !== 'string') return false;
  var digits = onlyNumbers(cep);
  return isValidLength$2(digits);
}

var PARTIALS = [{
  end: 9,
  start: 0,
  index: 9
}, {
  end: 20,
  start: 10,
  index: 20
}, {
  end: 31,
  start: 21,
  index: 31
}];
var DOT_INDEXES$1 = [4, 14, 25];
var SPACE_INDEXES = [9, 20, 31, 32];
var LENGTH$3 = 47;
var CHECK_DIGIT_POSITION = 4;
var MOD_11_WEIGHTS = {
  end: 9,
  initial: 2
};
var MOD_10_WEIGHTS = [2, 1];
var DIGITABLE_LINE_TO_BOLETO_CONVERT_POSITIONS = [{
  end: 4,
  start: 0
}, {
  end: 47,
  start: 32
}, {
  end: 9,
  start: 4
}, {
  end: 20,
  start: 10
}, {
  end: 31,
  start: 21
}];

function isValidLength$3(digitableLine) {
  return digitableLine.length === LENGTH$3;
}

function mod10(partial) {
  var sum = partial.split('').reverse().reduce(function (acc, digit, index) {
    var result = parseInt(digit, 10) * MOD_10_WEIGHTS[index % 2];
    return acc + (result > 9 ? 1 + result % 10 : result);
  }, 0);
  var mod = sum % 10;
  return mod > 0 ? 10 - mod : 0;
}

function mod11(value) {
  var initial = MOD_11_WEIGHTS.initial,
      end = MOD_11_WEIGHTS.end;
  var weight = initial;
  var sum = value.split('').reverse().reduce(function (acc, digit) {
    var result = parseInt(digit, 10) * weight;
    weight = weight < end ? weight + 1 : initial;
    return acc + result;
  }, 0);
  var mod = sum % 11;
  return mod === 0 || mod === 1 ? 1 : 11 - mod;
}

function isValidPartials(digitableLine) {
  return PARTIALS.every(function (_ref) {
    var start = _ref.start,
        end = _ref.end,
        index = _ref.index;
    var mod = mod10(digitableLine.substring(start, end));
    return +digitableLine[index] === mod;
  });
}

function parse(digitableLine) {
  return DIGITABLE_LINE_TO_BOLETO_CONVERT_POSITIONS.reduce(function (acc, pos) {
    return acc + digitableLine.substring(pos.start, pos.end);
  }, '');
}

function isValidCheckDigit(parsedDigitableLine) {
  var mod = mod11(parsedDigitableLine.slice(0, CHECK_DIGIT_POSITION) + parsedDigitableLine.slice(CHECK_DIGIT_POSITION + 1));
  return +parsedDigitableLine[CHECK_DIGIT_POSITION] === mod;
}

function isValid$6(digitableLine) {
  if (!digitableLine || typeof digitableLine !== 'string') return false;
  var digits = onlyNumbers(digitableLine);
  if (!isValidLength$3(digits)) return false;
  if (!isValidPartials(digits)) return false;
  var parsedDigits = parse(digits);
  return isValidCheckDigit(parsedDigits);
}
function format$2(boleto) {
  var digits = onlyNumbers(boleto);
  return digits.slice(0, LENGTH$3).split('').reduce(function (acc, digit, index) {
    var result = "" + acc + digit;

    if (!isLastChar(index, digits)) {
      if (DOT_INDEXES$1.indexOf(index) >= 0) return result + ".";
      if (SPACE_INDEXES.indexOf(index) >= 0) return result + " ";
    }

    return result;
  }, '');
}

function format$3(value, options) {
  if (options === void 0) {
    options = {
      precision: 2
    };
  }

  return value.toFixed(options.precision).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}
function parse$1(value) {
  return parseInt(value.replace(/\D/g, '') || '0', 10) / 100;
}

var LENGTH$4 = 11;
var DOT_INDEXES$2 = [2, 5];
var HYPHEN_INDEXES$2 = [8];
var RESERVED_NUMBERS$1 = ['00000000000', '11111111111', '22222222222', '33333333333', '44444444444', '55555555555', '66666666666', '77777777777', '88888888888', '99999999999'];
var CHECK_DIGITS_INDEXES = [9, 10];
function format$4(cpf, options) {
  if (options === void 0) {
    options = {};
  }

  var digits = onlyNumbers(cpf);

  if (options.pad) {
    digits = digits.padStart(LENGTH$4, '0');
  }

  return digits.slice(0, LENGTH$4).split('').reduce(function (acc, digit, i) {
    var result = "" + acc + digit;

    if (!isLastChar(i, digits)) {
      if (DOT_INDEXES$2.indexOf(i) >= 0) return result + ".";
      if (HYPHEN_INDEXES$2.indexOf(i) >= 0) return result + "-";
    }

    return result;
  }, '');
}
function generate(state) {
  var stateCode = state && STATES.includes(state) ? STATES_DATA[state].code : generateRandomNumber(1);
  var baseCPF = generateRandomNumber(LENGTH$4 - 3) + stateCode;
  var firstCheckDigitMod = generateChecksum(baseCPF, 10) % 11;
  var firstCheckDigit = (firstCheckDigitMod < 2 ? 0 : 11 - firstCheckDigitMod).toString();
  var secondCheckDigitMod = generateChecksum(baseCPF + firstCheckDigit, 11) % 11;
  var secondCheckDigit = (secondCheckDigitMod < 2 ? 0 : 11 - secondCheckDigitMod).toString();
  return "" + baseCPF + firstCheckDigit.toString() + secondCheckDigit.toString();
}
function isValidFormat(cpf) {
  return /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/.test(cpf);
}
function isReservedNumber$1(cpf) {
  return RESERVED_NUMBERS$1.indexOf(cpf) >= 0;
} // TODO: move to checksum helper

function isValidChecksum(cpf) {
  return CHECK_DIGITS_INDEXES.every(function (i) {
    var mod = generateChecksum(cpf.slice(0, i).split('').reduce(function (acc, digit) {
      return acc + digit;
    }, ''), i + 1) % 11;
    return cpf[i] === String(mod < 2 ? 0 : 11 - mod);
  });
}
function isValid$7(cpf) {
  if (!cpf || typeof cpf !== 'string') return false;
  var digits = onlyNumbers(cpf);
  return isValidFormat(cpf) && !isReservedNumber$1(digits) && isValidChecksum(digits);
}

var LENGTH$5 = 14;
var DOT_INDEXES$3 = [1, 4];
var SLASH_INDEXES = [7];
var HYPHEN_INDEXES$3 = [11];
var RESERVED_NUMBERS$2 = ['00000000000000', '11111111111111', '22222222222222', '33333333333333', '44444444444444', '55555555555555', '66666666666666', '77777777777777', '88888888888888', '99999999999999'];
var CHECK_DIGITS_INDEXES$1 = [12, 13];
var FIRST_CHECK_DIGIT_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
var SECOND_CHECK_DIGIT_WEIGHTS = /*#__PURE__*/[6].concat(FIRST_CHECK_DIGIT_WEIGHTS);
function format$5(cnpj, options) {
  if (options === void 0) {
    options = {};
  }

  var digits = onlyNumbers(cnpj);

  if (options.pad) {
    digits = digits.padStart(LENGTH$5, '0');
  }

  return digits.slice(0, LENGTH$5).split('').reduce(function (acc, digit, index) {
    var result = "" + acc + digit;

    if (!isLastChar(index, digits)) {
      if (DOT_INDEXES$3.includes(index)) return result + ".";
      if (SLASH_INDEXES.includes(index)) return result + "/";
      if (HYPHEN_INDEXES$3.includes(index)) return result + "-";
    }

    return result;
  }, '');
}
function generate$1() {
  var baseCNPJ = generateRandomNumber(LENGTH$5 - 2);
  var firstCheckDigitMod = generateChecksum(baseCNPJ, FIRST_CHECK_DIGIT_WEIGHTS) % 11;
  var firstCheckDigit = (firstCheckDigitMod < 2 ? 0 : 11 - firstCheckDigitMod).toString();
  var secondCheckDigitMod = generateChecksum(baseCNPJ + firstCheckDigit, SECOND_CHECK_DIGIT_WEIGHTS) % 11;
  var secondCheckDigit = (secondCheckDigitMod < 2 ? 0 : 11 - secondCheckDigitMod).toString();
  return "" + baseCNPJ + firstCheckDigit + secondCheckDigit;
}
function isValidFormat$1(cnpj) {
  return /^\d{2}\.?\d{3}\.?\d{3}\/?\d{4}-?\d{2}$/.test(cnpj);
}
function isReservedNumber$2(cpf) {
  return RESERVED_NUMBERS$2.indexOf(cpf) >= 0;
} // TODO: move to checksum helper

function isValidChecksum$1(cnpj) {
  var weights = [].concat(FIRST_CHECK_DIGIT_WEIGHTS);
  return CHECK_DIGITS_INDEXES$1.every(function (i) {
    if (i === CHECK_DIGITS_INDEXES$1[CHECK_DIGITS_INDEXES$1.length - 1]) {
      weights.unshift(6);
    }

    var mod = generateChecksum(cnpj.slice(0, i).split('').reduce(function (acc, digit) {
      return acc + digit;
    }, ''), weights) % 11;
    return cnpj[i] === String(mod < 2 ? 0 : 11 - mod);
  });
}
function isValid$8(cnpj) {
  if (!cnpj || typeof cnpj !== 'string') return false;
  var numbers = onlyNumbers(cnpj);
  return isValidFormat$1(cnpj) && !isReservedNumber$2(numbers) && isValidChecksum$1(numbers);
}

var ACRONYMS = ['cia', 'cnpj', 'cpf', 'ltda', 'me', 'rg'];
var PREPOSITIONS = ['a', 'com', 'da', 'das', 'de', 'do', 'dos', 'e', 'em', 'na', 'nas', 'no', 'nos', 'o', 'por', 'sem'];
function capitalize(value, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$lowerCaseWords = _ref.lowerCaseWords,
      lowerCaseWords = _ref$lowerCaseWords === void 0 ? PREPOSITIONS : _ref$lowerCaseWords,
      _ref$upperCaseWords = _ref.upperCaseWords,
      upperCaseWords = _ref$upperCaseWords === void 0 ? ACRONYMS : _ref$upperCaseWords;

  return value.split(' ').filter(function (word) {
    return !!word;
  }).map(function (word, index) {
    var lowerCaseWord = word.toLocaleLowerCase();
    if (index > 0 && lowerCaseWords.indexOf(lowerCaseWord) !== -1) return lowerCaseWord;
    var upperCaseWord = word.toLocaleUpperCase();
    if (upperCaseWords.indexOf(upperCaseWord) !== -1) return upperCaseWord;
    return upperCaseWord.charAt(0) + lowerCaseWord.substr(1);
  }).join(' ');
}

var stateNameComparer = function stateNameComparer(_ref, _ref2) {
  var nameA = _ref.name;
  var nameB = _ref2.name;
  return nameA.localeCompare(nameB);
};

var sortByStateName = function sortByStateName(states) {
  return states.sort(stateNameComparer);
};

function getStates() {
  var states = STATES.map(function (code) {
    return {
      code: code,
      name: STATES_DATA[code].name
    };
  });
  return sortByStateName(states);
}

var CITIES_DATA = {
  GO: ['Abadia de Goiás', 'Abadiânia', 'Acreúna', 'Adelândia', 'Alexânia', 'Aloândia', 'Alto Horizonte', 'Alto Paraíso de Goiás', 'Alvorada do Norte', 'Amaralina', 'Americano do Brasil', 'Amorinópolis', 'Anhanguera', 'Anicuns', 'Anápolis', 'Aparecida de Goiânia', 'Aparecida do Rio Doce', 'Aporé', 'Aragarças', 'Aragoiânia', 'Araguapaz', 'Araçu', 'Arenópolis', 'Aruanã', 'Aurilândia', 'Avelinópolis', 'Baliza', 'Barro Alto', 'Bela Vista de Goiás', 'Bom Jardim de Goiás', 'Bom Jesus de Goiás', 'Bonfinópolis', 'Bonópolis', 'Brazabrantes', 'Britânia', 'Buriti Alegre', 'Buriti de Goiás', 'Buritinópolis', 'Cabeceiras', 'Cachoeira Alta', 'Cachoeira Dourada', 'Cachoeira de Goiás', 'Caiapônia', 'Caldas Novas', 'Caldazinha', 'Campestre de Goiás', 'Campinaçu', 'Campinorte', 'Campo Alegre de Goiás', 'Campo Limpo de Goiás', 'Campos Belos', 'Campos Verdes', 'Carmo do Rio Verde', 'Castelândia', 'Catalão', 'Caturaí', 'Cavalcante', 'Caçu', 'Ceres', 'Cezarina', 'Chapadão do Céu', 'Cidade Ocidental', 'Cocalzinho de Goiás', 'Colinas do Sul', 'Corumbaíba', 'Corumbá de Goiás', 'Cristalina', 'Cristianópolis', 'Crixás', 'Cromínia', 'Cumari', 'Córrego do Ouro', 'Damianópolis', 'Damolândia', 'Davinópolis', 'Diorama', 'Divinópolis de Goiás', 'Doverlândia', 'Edealina', 'Edéia', 'Estrela do Norte', 'Faina', 'Fazenda Nova', 'Firminópolis', 'Flores de Goiás', 'Formosa', 'Formoso', 'Gameleira de Goiás', 'Goiandira', 'Goianira', 'Goianápolis', 'Goianésia', 'Goiatuba', 'Goiás', 'Goiânia', 'Gouvelândia', 'Guapó', 'Guarani de Goiás', 'Guaraíta', 'Guarinos', 'Heitoraí', 'Hidrolina', 'Hidrolândia', 'Iaciara', 'Inaciolândia', 'Indiara', 'Inhumas', 'Ipameri', 'Ipiranga de Goiás', 'Iporá', 'Israelândia', 'Itaberaí', 'Itaguari', 'Itaguaru', 'Itajá', 'Itapaci', 'Itapirapuã', 'Itapuranga', 'Itarumã', 'Itauçu', 'Itumbiara', 'Ivolândia', 'Jandaia', 'Jaraguá', 'Jataí', 'Jaupaci', 'Jesúpolis', 'Joviânia', 'Jussara', 'Lagoa Santa', 'Leopoldo de Bulhões', 'Luziânia', 'Mairipotaba', 'Mambaí', 'Mara Rosa', 'Marzagão', 'Matrinchã', 'Maurilândia', 'Mimoso de Goiás', 'Minaçu', 'Mineiros', 'Moiporá', 'Monte Alegre de Goiás', 'Montes Claros de Goiás', 'Montividiu', 'Montividiu do Norte', 'Morrinhos', 'Morro Agudo de Goiás', 'Mossâmedes', 'Mozarlândia', 'Mundo Novo', 'Mutunópolis', 'Nazário', 'Nerópolis', 'Niquelândia', 'Nova América', 'Nova Aurora', 'Nova Crixás', 'Nova Glória', 'Nova Iguaçu de Goiás', 'Nova Roma', 'Nova Veneza', 'Novo Brasil', 'Novo Gama', 'Novo Planalto', 'Orizona', 'Ouro Verde de Goiás', 'Ouvidor', 'Padre Bernardo', 'Palestina de Goiás', 'Palmeiras de Goiás', 'Palmelo', 'Palminópolis', 'Panamá', 'Paranaiguara', 'Paraúna', 'Perolândia', 'Petrolina de Goiás', 'Pilar de Goiás', 'Piracanjuba', 'Piranhas', 'Pirenópolis', 'Pires do Rio', 'Planaltina', 'Pontalina', 'Porangatu', 'Porteirão', 'Portelândia', 'Posse', 'Professor Jamil', 'Quirinópolis', 'Rialma', 'Rianápolis', 'Rio Quente', 'Rio Verde', 'Rubiataba', 'Sanclerlândia', 'Santa Bárbara de Goiás', 'Santa Cruz de Goiás', 'Santa Fé de Goiás', 'Santa Helena de Goiás', 'Santa Isabel', 'Santa Rita do Araguaia', 'Santa Rita do Novo Destino', 'Santa Rosa de Goiás', 'Santa Tereza de Goiás', 'Santa Terezinha de Goiás', 'Santo Antônio da Barra', 'Santo Antônio de Goiás', 'Santo Antônio do Descoberto', 'Senador Canedo', 'Serranópolis', 'Silvânia', 'Simolândia', 'São Domingos', 'São Francisco de Goiás', "São João d'Aliança", 'São João da Paraúna', 'São Luiz do Norte', 'São Luís de Montes Belos', 'São Miguel do Araguaia', 'São Miguel do Passa Quatro', 'São Patrício', 'São Simão', "Sítio d'Abadia", 'Taquaral de Goiás', 'Teresina de Goiás', 'Terezópolis de Goiás', 'Trindade', 'Trombas', 'Três Ranchos', 'Turvelândia', 'Turvânia', 'Uirapuru', 'Uruana', 'Uruaçu', 'Urutaí', 'Valparaíso de Goiás', 'Varjão', 'Vianópolis', 'Vicentinópolis', 'Vila Boa', 'Vila Propício', 'Água Fria de Goiás', 'Água Limpa', 'Águas Lindas de Goiás'],
  MG: ['Abadia dos Dourados', 'Abaeté', 'Abre Campo', 'Acaiaca', 'Aguanil', 'Aimorés', 'Aiuruoca', 'Alagoa', 'Albertina', 'Alfenas', 'Alfredo Vasconcelos', 'Almenara', 'Alpercata', 'Alpinópolis', 'Alterosa', 'Alto Caparaó', 'Alto Jequitibá', 'Alto Rio Doce', 'Alvarenga', 'Alvinópolis', 'Alvorada de Minas', 'Além Paraíba', 'Amparo do Serra', 'Andradas', 'Andrelândia', 'Angelândia', 'Antônio Carlos', 'Antônio Dias', 'Antônio Prado de Minas', 'Aracitaba', 'Araguari', 'Arantina', 'Araponga', 'Araporã', 'Arapuá', 'Araxá', 'Araçaí', 'Araçuaí', 'Araújos', 'Arceburgo', 'Arcos', 'Areado', 'Argirita', 'Aricanduva', 'Arinos', 'Astolfo Dutra', 'Ataléia', 'Augusto de Lima', 'Açucena', 'Baependi', 'Baldim', 'Bambuí', 'Bandeira', 'Bandeira do Sul', 'Barbacena', 'Barra Longa', 'Barroso', 'Barão de Cocais', 'Barão de Monte Alto', 'Bela Vista de Minas', 'Belmiro Braga', 'Belo Horizonte', 'Belo Oriente', 'Belo Vale', 'Berilo', 'Berizal', 'Bertópolis', 'Betim', 'Bias Fortes', 'Bicas', 'Biquinhas', 'Boa Esperança', 'Bocaina de Minas', 'Bocaiúva', 'Bom Despacho', 'Bom Jardim de Minas', 'Bom Jesus da Penha', 'Bom Jesus do Amparo', 'Bom Jesus do Galho', 'Bom Repouso', 'Bom Sucesso', 'Bonfim', 'Bonfinópolis de Minas', 'Bonito de Minas', 'Borda da Mata', 'Botelhos', 'Botumirim', 'Brasilândia de Minas', 'Brasília de Minas', 'Brazópolis', 'Braúnas', 'Brumadinho', 'Brás Pires', 'Bueno Brandão', 'Buenópolis', 'Bugre', 'Buritis', 'Buritizeiro', 'Cabeceira Grande', 'Cabo Verde', 'Cachoeira Dourada', 'Cachoeira da Prata', 'Cachoeira de Minas', 'Cachoeira de Pajeú', 'Caetanópolis', 'Caeté', 'Caiana', 'Cajuri', 'Caldas', 'Camacho', 'Camanducaia', 'Cambuquira', 'Cambuí', 'Campanha', 'Campanário', 'Campestre', 'Campina Verde', 'Campo Azul', 'Campo Belo', 'Campo Florido', 'Campo do Meio', 'Campos Altos', 'Campos Gerais', 'Cana Verde', 'Canaã', 'Candeias', 'Cantagalo', 'Canápolis', 'Caparaó', 'Capela Nova', 'Capelinha', 'Capetinga', 'Capim Branco', 'Capinópolis', 'Capitão Andrade', 'Capitão Enéas', 'Capitólio', 'Caputira', 'Caranaíba', 'Carandaí', 'Carangola', 'Caratinga', 'Caraí', 'Carbonita', 'Careaçu', 'Carlos Chagas', 'Carmo da Cachoeira', 'Carmo da Mata', 'Carmo de Minas', 'Carmo do Cajuru', 'Carmo do Paranaíba', 'Carmo do Rio Claro', 'Carmésia', 'Carmópolis de Minas', 'Carneirinho', 'Carrancas', 'Carvalhos', 'Carvalhópolis', 'Casa Grande', 'Cascalho Rico', 'Cataguases', 'Catas Altas', 'Catas Altas da Noruega', 'Catuji', 'Catuti', 'Caxambu', 'Cedro do Abaeté', 'Central de Minas', 'Centralina', 'Chalé', 'Chapada Gaúcha', 'Chapada do Norte', 'Chiador', 'Chácara', 'Cipotânea', 'Claraval', 'Claro dos Poções', 'Cláudio', 'Coimbra', 'Coluna', 'Comendador Gomes', 'Comercinho', 'Conceição da Aparecida', 'Conceição da Barra de Minas', 'Conceição das Alagoas', 'Conceição das Pedras', 'Conceição de Ipanema', 'Conceição do Mato Dentro', 'Conceição do Pará', 'Conceição do Rio Verde', 'Conceição dos Ouros', 'Confins', 'Congonhal', 'Congonhas', 'Congonhas do Norte', 'Conquista', 'Conselheiro Lafaiete', 'Conselheiro Pena', 'Consolação', 'Contagem', 'Coqueiral', 'Coração de Jesus', 'Cordisburgo', 'Cordislândia', 'Corinto', 'Coroaci', 'Coromandel', 'Coronel Fabriciano', 'Coronel Murta', 'Coronel Pacheco', 'Coronel Xavier Chaves', 'Couto de Magalhães de Minas', 'Cristais', 'Cristiano Otoni', 'Cristina', 'Cristália', 'Crisólita', 'Crucilândia', 'Cruzeiro da Fortaleza', 'Cruzília', 'Cuparaque', 'Curral de Dentro', 'Curvelo', 'Cássia', 'Córrego Danta', 'Córrego Fundo', 'Córrego Novo', 'Córrego do Bom Jesus', 'Cônego Marinho', 'Datas', 'Delfim Moreira', 'Delfinópolis', 'Delta', 'Descoberto', 'Desterro de Entre Rios', 'Desterro do Melo', 'Diamantina', 'Diogo de Vasconcelos', 'Dionísio', 'Divino', 'Divino das Laranjeiras', 'Divinolândia de Minas', 'Divinésia', 'Divinópolis', 'Divisa Alegre', 'Divisa Nova', 'Divisópolis', 'Dom Bosco', 'Dom Cavati', 'Dom Joaquim', 'Dom Silvério', 'Dom Viçoso', 'Dona Euzébia', 'Dores de Campos', 'Dores de Guanhães', 'Dores do Indaiá', 'Dores do Turvo', 'Doresópolis', 'Douradoquara', 'Durandé', 'Elói Mendes', 'Engenheiro Caldas', 'Engenheiro Navarro', 'Entre Folhas', 'Entre Rios de Minas', 'Ervália', 'Esmeraldas', 'Espera Feliz', 'Espinosa', 'Espírito Santo do Dourado', 'Estiva', 'Estrela Dalva', 'Estrela do Indaiá', 'Estrela do Sul', 'Eugenópolis', 'Ewbank da Câmara', 'Extrema', 'Fama', 'Faria Lemos', 'Felisburgo', 'Felixlândia', 'Felício dos Santos', 'Fernandes Tourinho', 'Ferros', 'Fervedouro', 'Florestal', 'Formiga', 'Formoso', 'Fortaleza de Minas', 'Fortuna de Minas', 'Francisco Badaró', 'Francisco Dumont', 'Francisco Sá', 'Franciscópolis', 'Frei Gaspar', 'Frei Inocêncio', 'Frei Lagonegro', 'Fronteira', 'Fronteira dos Vales', 'Fruta de Leite', 'Frutal', 'Funilândia', 'Galiléia', 'Gameleiras', 'Glaucilândia', 'Goiabeira', 'Goianá', 'Gonzaga', 'Gonçalves', 'Gouveia', 'Governador Valadares', 'Grupiara', 'Grão Mogol', 'Guanhães', 'Guapé', 'Guaraciaba', 'Guaraciama', 'Guarani', 'Guaranésia', 'Guarará', 'Guarda-Mor', 'Guaxupé', 'Guidoval', 'Guimarânia', 'Guiricema', 'Gurinhatã', 'Heliodora', 'Iapu', 'Ibertioga', 'Ibiaí', 'Ibiracatu', 'Ibiraci', 'Ibirité', 'Ibitiúra de Minas', 'Ibituruna', 'Ibiá', 'Icaraí de Minas', 'Igarapé', 'Igaratinga', 'Iguatama', 'Ijaci', 'Ilicínea', 'Imbé de Minas', 'Inconfidentes', 'Indaiabira', 'Indianópolis', 'Ingaí', 'Inhapim', 'Inhaúma', 'Inimutaba', 'Ipaba', 'Ipanema', 'Ipatinga', 'Ipiaçu', 'Ipuiúna', 'Iraí de Minas', 'Itabira', 'Itabirinha', 'Itabirito', 'Itacambira', 'Itacarambi', 'Itaguara', 'Itaipé', 'Itajubá', 'Itamarandiba', 'Itamarati de Minas', 'Itambacuri', 'Itambé do Mato Dentro', 'Itamogi', 'Itamonte', 'Itanhandu', 'Itanhomi', 'Itaobim', 'Itapagipe', 'Itapecerica', 'Itapeva', 'Itatiaiuçu', 'Itaverava', 'Itaú de Minas', 'Itaúna', 'Itinga', 'Itueta', 'Ituiutaba', 'Itumirim', 'Iturama', 'Itutinga', 'Jaboticatubas', 'Jacinto', 'Jacutinga', 'Jacuí', 'Jaguaraçu', 'Jampruca', 'Janaúba', 'Januária', 'Japaraíba', 'Japonvar', 'Jaíba', 'Jeceaba', 'Jenipapo de Minas', 'Jequeri', 'Jequitaí', 'Jequitibá', 'Jequitinhonha', 'Jesuânia', 'Joanésia', 'Joaquim Felício', 'Joaíma', 'Jordânia', 'Josenópolis', 'José Gonçalves de Minas', 'José Raydan', 'João Monlevade', 'João Pinheiro', 'Juatuba', 'Juiz de Fora', 'Juramento', 'Juruaia', 'Juvenília', 'Ladainha', 'Lagamar', 'Lagoa Dourada', 'Lagoa Formosa', 'Lagoa Grande', 'Lagoa Santa', 'Lagoa da Prata', 'Lagoa dos Patos', 'Lajinha', 'Lambari', 'Lamim', 'Laranjal', 'Lassance', 'Lavras', 'Leandro Ferreira', 'Leme do Prado', 'Leopoldina', 'Liberdade', 'Lima Duarte', 'Limeira do Oeste', 'Lontra', 'Luisburgo', 'Luislândia', 'Luminárias', 'Luz', 'Machacalis', 'Machado', 'Madre de Deus de Minas', 'Malacacheta', 'Mamonas', 'Manga', 'Manhuaçu', 'Manhumirim', 'Mantena', 'Mar de Espanha', 'Maravilhas', 'Maria da Fé', 'Mariana', 'Marilac', 'Maripá de Minas', 'Marliéria', 'Marmelópolis', 'Martinho Campos', 'Martins Soares', 'Mata Verde', 'Materlândia', 'Mateus Leme', 'Mathias Lobato', 'Matias Barbosa', 'Matias Cardoso', 'Matipó', 'Mato Verde', 'Matozinhos', 'Matutina', 'Medeiros', 'Medina', 'Mendes Pimentel', 'Mercês', 'Mesquita', 'Minas Novas', 'Minduri', 'Mirabela', 'Miradouro', 'Miravânia', 'Miraí', 'Moeda', 'Moema', 'Monjolos', 'Monsenhor Paulo', 'Montalvânia', 'Monte Alegre de Minas', 'Monte Azul', 'Monte Belo', 'Monte Carmelo', 'Monte Formoso', 'Monte Santo de Minas', 'Monte Sião', 'Montes Claros', 'Montezuma', 'Morada Nova de Minas', 'Morro da Garça', 'Morro do Pilar', 'Munhoz', 'Muriaé', 'Mutum', 'Muzambinho', 'Mário Campos', 'Nacip Raydan', 'Nanuque', 'Naque', 'Natalândia', 'Natércia', 'Nazareno', 'Nepomuceno', 'Ninheira', 'Nova Belém', 'Nova Era', 'Nova Lima', 'Nova Módica', 'Nova Ponte', 'Nova Porteirinha', 'Nova Resende', 'Nova Serrana', 'Nova União', 'Novo Cruzeiro', 'Novo Oriente de Minas', 'Novorizonte', 'Olaria', "Olhos-d'Água", 'Oliveira', 'Oliveira Fortes', 'Olímpio Noronha', 'Onça de Pitangui', 'Oratórios', 'Orizânia', 'Ouro Branco', 'Ouro Fino', 'Ouro Preto', 'Ouro Verde de Minas', 'Padre Carvalho', 'Padre Paraíso', 'Pai Pedro', 'Paineiras', 'Pains', 'Paiva', 'Palma', 'Palmópolis', 'Papagaios', 'Paracatu', 'Paraguaçu', 'Paraisópolis', 'Paraopeba', 'Pará de Minas', 'Passa Quatro', 'Passa Tempo', 'Passa Vinte', 'Passabém', 'Passos', 'Patis', 'Patos de Minas', 'Patrocínio', 'Patrocínio do Muriaé', 'Paula Cândido', 'Paulistas', 'Pavão', 'Pedra Azul', 'Pedra Bonita', 'Pedra Dourada', 'Pedra do Anta', 'Pedra do Indaiá', 'Pedralva', 'Pedras de Maria da Cruz', 'Pedrinópolis', 'Pedro Leopoldo', 'Pedro Teixeira', 'Pequeri', 'Pequi', 'Perdigão', 'Perdizes', 'Perdões', 'Periquito', 'Pescador', 'Peçanha', 'Piau', 'Piedade de Caratinga', 'Piedade de Ponte Nova', 'Piedade do Rio Grande', 'Piedade dos Gerais', 'Pimenta', "Pingo d'Água", 'Pintópolis', 'Piracema', 'Pirajuba', 'Piranga', 'Piranguinho', 'Piranguçu', 'Pirapetinga', 'Pirapora', 'Piraúba', 'Pitangui', 'Piumhi', 'Planura', 'Pocrane', 'Pompéu', 'Ponte Nova', 'Ponto Chique', 'Ponto dos Volantes', 'Porteirinha', 'Porto Firme', 'Poté', 'Pouso Alegre', 'Pouso Alto', 'Poço Fundo', 'Poços de Caldas', 'Prados', 'Prata', 'Pratinha', 'Pratápolis', 'Presidente Bernardes', 'Presidente Juscelino', 'Presidente Kubitschek', 'Presidente Olegário', 'Prudente de Morais', 'Quartel Geral', 'Queluzito', 'Raposos', 'Raul Soares', 'Recreio', 'Reduto', 'Resende Costa', 'Resplendor', 'Ressaquinha', 'Riachinho', 'Riacho dos Machados', 'Ribeirão Vermelho', 'Ribeirão das Neves', 'Rio Acima', 'Rio Casca', 'Rio Doce', 'Rio Espera', 'Rio Manso', 'Rio Novo', 'Rio Paranaíba', 'Rio Pardo de Minas', 'Rio Piracicaba', 'Rio Pomba', 'Rio Preto', 'Rio Vermelho', 'Rio do Prado', 'Ritápolis', 'Rochedo de Minas', 'Rodeiro', 'Romaria', 'Rosário da Limeira', 'Rubelita', 'Rubim', 'Sabará', 'Sabinópolis', 'Sacramento', 'Salinas', 'Salto da Divisa', 'Santa Bárbara', 'Santa Bárbara do Leste', 'Santa Bárbara do Monte Verde', 'Santa Bárbara do Tugúrio', 'Santa Cruz de Minas', 'Santa Cruz de Salinas', 'Santa Cruz do Escalvado', 'Santa Efigênia de Minas', 'Santa Fé de Minas', 'Santa Helena de Minas', 'Santa Juliana', 'Santa Luzia', 'Santa Margarida', 'Santa Maria de Itabira', 'Santa Maria do Salto', 'Santa Maria do Suaçuí', 'Santa Rita de Caldas', 'Santa Rita de Ibitipoca', 'Santa Rita de Jacutinga', 'Santa Rita de Minas', 'Santa Rita do Itueto', 'Santa Rita do Sapucaí', 'Santa Rosa da Serra', 'Santa Vitória', 'Santana da Vargem', 'Santana de Cataguases', 'Santana de Pirapama', 'Santana do Deserto', 'Santana do Garambéu', 'Santana do Jacaré', 'Santana do Manhuaçu', 'Santana do Paraíso', 'Santana do Riacho', 'Santana dos Montes', 'Santo Antônio do Amparo', 'Santo Antônio do Aventureiro', 'Santo Antônio do Grama', 'Santo Antônio do Itambé', 'Santo Antônio do Jacinto', 'Santo Antônio do Monte', 'Santo Antônio do Retiro', 'Santo Antônio do Rio Abaixo', 'Santo Hipólito', 'Santos Dumont', 'Sapucaí-Mirim', 'Sardoá', 'Sarzedo', 'Sem-Peixe', 'Senador Amaral', 'Senador Cortes', 'Senador Firmino', 'Senador José Bento', 'Senador Modestino Gonçalves', 'Senhora de Oliveira', 'Senhora do Porto', 'Senhora dos Remédios', 'Sericita', 'Seritinga', 'Serra Azul de Minas', 'Serra da Saudade', 'Serra do Salitre', 'Serra dos Aimorés', 'Serrania', 'Serranos', 'Serranópolis de Minas', 'Serro', 'Sete Lagoas', 'Setubinha', 'Silveirânia', 'Silvianópolis', 'Simonésia', 'Simão Pereira', 'Sobrália', 'Soledade de Minas', 'São Bento Abade', 'São Brás do Suaçuí', 'São Domingos das Dores', 'São Domingos do Prata', 'São Francisco', 'São Francisco de Paula', 'São Francisco de Sales', 'São Francisco do Glória', 'São Félix de Minas', 'São Geraldo', 'São Geraldo da Piedade', 'São Geraldo do Baixio', 'São Gonçalo do Abaeté', 'São Gonçalo do Pará', 'São Gonçalo do Rio Abaixo', 'São Gonçalo do Rio Preto', 'São Gonçalo do Sapucaí', 'São Gotardo', 'São Joaquim de Bicas', 'São José da Barra', 'São José da Lapa', 'São José da Safira', 'São José da Varginha', 'São José do Alegre', 'São José do Divino', 'São José do Goiabal', 'São José do Jacuri', 'São José do Mantimento', 'São João Batista do Glória', 'São João Evangelista', 'São João Nepomuceno', 'São João da Lagoa', 'São João da Mata', 'São João da Ponte', 'São João das Missões', 'São João del Rei', 'São João do Manhuaçu', 'São João do Manteninha', 'São João do Oriente', 'São João do Pacuí', 'São João do Paraíso', 'São Lourenço', 'São Miguel do Anta', 'São Pedro da União', 'São Pedro do Suaçuí', 'São Pedro dos Ferros', 'São Romão', 'São Roque de Minas', 'São Sebastião da Bela Vista', 'São Sebastião da Vargem Alegre', 'São Sebastião do Anta', 'São Sebastião do Maranhão', 'São Sebastião do Oeste', 'São Sebastião do Paraíso', 'São Sebastião do Rio Preto', 'São Sebastião do Rio Verde', 'São Tiago', 'São Tomás de Aquino', 'São Tomé das Letras', 'São Vicente de Minas', 'Tabuleiro', 'Taiobeiras', 'Taparuba', 'Tapira', 'Tapiraí', 'Taquaraçu de Minas', 'Tarumirim', 'Teixeiras', 'Teófilo Otoni', 'Timóteo', 'Tiradentes', 'Tiros', 'Tocantins', 'Tocos do Moji', 'Toledo', 'Tombos', 'Três Corações', 'Três Marias', 'Três Pontas', 'Tumiritinga', 'Tupaciguara', 'Turmalina', 'Turvolândia', 'Ubaporanga', 'Ubaí', 'Uberaba', 'Uberlândia', 'Ubá', 'Umburatiba', 'Unaí', 'União de Minas', 'Uruana de Minas', 'Urucuia', 'Urucânia', 'Vargem Alegre', 'Vargem Bonita', 'Vargem Grande do Rio Pardo', 'Varginha', 'Varjão de Minas', 'Varzelândia', 'Vazante', 'Verdelândia', 'Veredinha', 'Vermelho Novo', 'Veríssimo', 'Vespasiano', 'Vieiras', 'Virgem da Lapa', 'Virginópolis', 'Virgolândia', 'Virgínia', 'Visconde do Rio Branco', 'Viçosa', 'Volta Grande', 'Várzea da Palma', 'Wenceslau Braz', 'Água Boa', 'Água Comprida', 'Águas Formosas', 'Águas Vermelhas'],
  PA: ['Abaetetuba', 'Abel Figueiredo', 'Acará', 'Afuá', 'Alenquer', 'Almeirim', 'Altamira', 'Anajás', 'Ananindeua', 'Anapu', 'Augusto Corrêa', 'Aurora do Pará', 'Aveiro', 'Bagre', 'Baião', 'Bannach', 'Barcarena', 'Belterra', 'Belém', 'Benevides', 'Bom Jesus do Tocantins', 'Bonito', 'Bragança', 'Brasil Novo', 'Brejo Grande do Araguaia', 'Breu Branco', 'Breves', 'Bujaru', 'Cachoeira do Arari', 'Cachoeira do Piriá', 'Cametá', 'Canaã dos Carajás', 'Capanema', 'Capitão Poço', 'Castanhal', 'Chaves', 'Colares', 'Conceição do Araguaia', 'Concórdia do Pará', 'Cumaru do Norte', 'Curionópolis', 'Curralinho', 'Curuá', 'Curuçá', 'Dom Eliseu', 'Eldorado do Carajás', 'Faro', 'Floresta do Araguaia', 'Garrafão do Norte', 'Goianésia do Pará', 'Gurupá', 'Igarapé-Açu', 'Igarapé-Miri', 'Inhangapi', 'Ipixuna do Pará', 'Irituia', 'Itaituba', 'Itupiranga', 'Jacareacanga', 'Jacundá', 'Juruti', 'Limoeiro do Ajuru', 'Magalhães Barata', 'Marabá', 'Maracanã', 'Marapanim', 'Marituba', 'Medicilândia', 'Melgaço', 'Mocajuba', 'Moju', 'Mojuí dos Campos', 'Monte Alegre', 'Muaná', 'Mãe do Rio', 'Nova Esperança do Piriá', 'Nova Ipixuna', 'Nova Timboteua', 'Novo Progresso', 'Novo Repartimento', 'Oeiras do Pará', 'Oriximiná', 'Ourilândia do Norte', 'Ourém', 'Pacajá', 'Palestina do Pará', 'Paragominas', 'Parauapebas', "Pau D'Arco", 'Peixe-Boi', 'Piçarra', 'Placas', 'Ponta de Pedras', 'Portel', 'Porto de Moz', 'Prainha', 'Primavera', 'Quatipuru', 'Redenção', 'Rio Maria', 'Rondon do Pará', 'Rurópolis', 'Salinópolis', 'Salvaterra', 'Santa Bárbara do Pará', 'Santa Cruz do Arari', 'Santa Izabel do Pará', 'Santa Luzia do Pará', 'Santa Maria das Barreiras', 'Santa Maria do Pará', 'Santana do Araguaia', 'Santarém', 'Santarém Novo', 'Santo Antônio do Tauá', 'Sapucaia', 'Senador José Porfírio', 'Soure', 'São Caetano de Odivelas', 'São Domingos do Araguaia', 'São Domingos do Capim', 'São Francisco do Pará', 'São Félix do Xingu', 'São Geraldo do Araguaia', 'São João da Ponta', 'São João de Pirabas', 'São João do Araguaia', 'São Miguel do Guamá', 'São Sebastião da Boa Vista', 'Tailândia', 'Terra Alta', 'Terra Santa', 'Tomé-Açu', 'Tracuateua', 'Trairão', 'Tucumã', 'Tucuruí', 'Ulianópolis', 'Uruará', 'Vigia', 'Viseu', 'Vitória do Xingu', 'Xinguara', 'Água Azul do Norte', 'Óbidos'],
  CE: ['Abaiara', 'Acarape', 'Acaraú', 'Acopiara', 'Aiuaba', 'Alcântaras', 'Altaneira', 'Alto Santo', 'Amontada', 'Antonina do Norte', 'Apuiarés', 'Aquiraz', 'Aracati', 'Aracoiaba', 'Ararendá', 'Araripe', 'Aratuba', 'Arneiroz', 'Assaré', 'Aurora', 'Baixio', 'Banabuiú', 'Barbalha', 'Barreira', 'Barro', 'Barroquinha', 'Baturité', 'Beberibe', 'Bela Cruz', 'Boa Viagem', 'Brejo Santo', 'Camocim', 'Campos Sales', 'Canindé', 'Capistrano', 'Caridade', 'Caririaçu', 'Cariré', 'Cariús', 'Carnaubal', 'Cascavel', 'Catarina', 'Catunda', 'Caucaia', 'Cedro', 'Chaval', 'Chorozinho', 'Choró', 'Coreaú', 'Crateús', 'Crato', 'Croatá', 'Cruz', 'Deputado Irapuan Pinheiro', 'Ereré', 'Eusébio', 'Farias Brito', 'Forquilha', 'Fortaleza', 'Fortim', 'Frecheirinha', 'General Sampaio', 'Granja', 'Granjeiro', 'Graça', 'Groaíras', 'Guaiúba', 'Guaraciaba do Norte', 'Guaramiranga', 'Hidrolândia', 'Horizonte', 'Ibaretama', 'Ibiapina', 'Ibicuitinga', 'Icapuí', 'Icó', 'Iguatu', 'Independência', 'Ipaporanga', 'Ipaumirim', 'Ipu', 'Ipueiras', 'Iracema', 'Irauçuba', 'Itaitinga', 'Itaiçaba', 'Itapajé', 'Itapipoca', 'Itapiúna', 'Itarema', 'Itatira', 'Jaguaretama', 'Jaguaribara', 'Jaguaribe', 'Jaguaruana', 'Jardim', 'Jati', 'Jijoca de Jericoacoara', 'Juazeiro do Norte', 'Jucás', 'Lavras da Mangabeira', 'Limoeiro do Norte', 'Madalena', 'Maracanaú', 'Maranguape', 'Marco', 'Martinópole', 'Massapê', 'Mauriti', 'Meruoca', 'Milagres', 'Milhã', 'Miraíma', 'Missão Velha', 'Mombaça', 'Monsenhor Tabosa', 'Morada Nova', 'Moraújo', 'Morrinhos', 'Mucambo', 'Mulungu', 'Nova Olinda', 'Nova Russas', 'Novo Oriente', 'Ocara', 'Orós', 'Pacajus', 'Pacatuba', 'Pacoti', 'Pacujá', 'Palhano', 'Palmácia', 'Paracuru', 'Paraipaba', 'Parambu', 'Paramoti', 'Pedra Branca', 'Penaforte', 'Pentecoste', 'Pereiro', 'Pindoretama', 'Piquet Carneiro', 'Pires Ferreira', 'Poranga', 'Porteiras', 'Potengi', 'Potiretama', 'Quiterianópolis', 'Quixadá', 'Quixelô', 'Quixeramobim', 'Quixeré', 'Redenção', 'Reriutaba', 'Russas', 'Saboeiro', 'Salitre', 'Santa Quitéria', 'Santana do Acaraú', 'Santana do Cariri', 'Senador Pompeu', 'Senador Sá', 'Sobral', 'Solonópole', 'São Benedito', 'São Gonçalo do Amarante', 'São João do Jaguaribe', 'São Luís do Curu', 'Tabuleiro do Norte', 'Tamboril', 'Tarrafas', 'Tauá', 'Tejuçuoca', 'Tianguá', 'Trairi', 'Tururu', 'Ubajara', 'Umari', 'Umirim', 'Uruburetama', 'Uruoca', 'Varjota', 'Viçosa do Ceará', 'Várzea Alegre'],
  BA: ['Abaré', 'Abaíra', 'Acajutiba', 'Adustina', 'Aiquara', 'Alagoinhas', 'Alcobaça', 'Almadina', 'Amargosa', 'Amélia Rodrigues', 'América Dourada', 'Anagé', 'Andaraí', 'Andorinha', 'Angical', 'Anguera', 'Antas', 'Antônio Cardoso', 'Antônio Gonçalves', 'Aporá', 'Apuarema', 'Aracatu', 'Araci', 'Aramari', 'Arataca', 'Aratuípe', 'Araçás', 'Aurelino Leal', 'Baianópolis', 'Baixa Grande', 'Banzaê', 'Barra', 'Barra da Estiva', 'Barra do Choça', 'Barra do Mendes', 'Barra do Rocha', 'Barreiras', 'Barro Alto', 'Barro Preto', 'Barrocas', 'Belmonte', 'Belo Campo', 'Biritinga', 'Boa Nova', 'Boa Vista do Tupim', 'Bom Jesus da Lapa', 'Bom Jesus da Serra', 'Boninal', 'Bonito', 'Boquira', 'Botuporã', 'Brejolândia', 'Brejões', 'Brotas de Macaúbas', 'Brumado', 'Buerarema', 'Buritirama', 'Caatiba', 'Cabaceiras do Paraguaçu', 'Cachoeira', 'Caculé', 'Caetanos', 'Caetité', 'Cafarnaum', 'Cairu', 'Caldeirão Grande', 'Camacan', 'Camamu', 'Camaçari', 'Campo Alegre de Lourdes', 'Campo Formoso', 'Canarana', 'Canavieiras', 'Candeal', 'Candeias', 'Candiba', 'Cansanção', 'Canudos', 'Canápolis', 'Capela do Alto Alegre', 'Capim Grosso', 'Caravelas', 'Caraíbas', 'Cardeal da Silva', 'Carinhanha', 'Casa Nova', 'Castro Alves', 'Catolândia', 'Catu', 'Caturama', 'Caém', 'Central', 'Chorrochó', 'Cipó', 'Coaraci', 'Cocos', 'Conceição da Feira', 'Conceição do Almeida', 'Conceição do Coité', 'Conceição do Jacuípe', 'Conde', 'Condeúba', 'Contendas do Sincorá', 'Coração de Maria', 'Cordeiros', 'Coribe', 'Coronel João Sá', 'Correntina', 'Cotegipe', 'Cravolândia', 'Cristópolis', 'Crisópolis', 'Cruz das Almas', 'Curaçá', 'Cândido Sales', 'Cícero Dantas', "Dias d'Ávila", 'Dom Basílio', 'Dom Macedo Costa', 'Dário Meira', 'Elísio Medrado', 'Encruzilhada', 'Entre Rios', 'Esplanada', 'Euclides da Cunha', 'Eunápolis', 'Feira da Mata', 'Feira de Santana', 'Filadélfia', 'Firmino Alves', 'Floresta Azul', 'Formosa do Rio Preto', 'Fátima', 'Gandu', 'Gavião', 'Gentio do Ouro', 'Glória', 'Gongogi', 'Governador Mangabeira', 'Guajeru', 'Guanambi', 'Guaratinga', 'Heliópolis', 'Iaçu', 'Ibiassucê', 'Ibicaraí', 'Ibicoara', 'Ibicuí', 'Ibipeba', 'Ibipitanga', 'Ibiquera', 'Ibirapitanga', 'Ibirapuã', 'Ibirataia', 'Ibitiara', 'Ibititá', 'Ibotirama', 'Ichu', 'Igaporã', 'Igrapiúna', 'Iguaí', 'Ilhéus', 'Inhambupe', 'Ipecaetá', 'Ipiaú', 'Ipirá', 'Ipupiara', 'Irajuba', 'Iramaia', 'Iraquara', 'Irará', 'Irecê', 'Itabela', 'Itaberaba', 'Itabuna', 'Itacaré', 'Itaeté', 'Itagi', 'Itagibá', 'Itagimirim', 'Itaguaçu da Bahia', 'Itaju do Colônia', 'Itajuípe', 'Itamaraju', 'Itamari', 'Itambé', 'Itanagra', 'Itanhém', 'Itaparica', 'Itapebi', 'Itapetinga', 'Itapicuru', 'Itapitanga', 'Itapé', 'Itaquara', 'Itarantim', 'Itatim', 'Itiruçu', 'Itiúba', 'Itororó', 'Ituaçu', 'Ituberá', 'Iuiu', 'Jaborandi', 'Jacaraci', 'Jacobina', 'Jaguaquara', 'Jaguarari', 'Jaguaripe', 'Jandaíra', 'Jequié', 'Jeremoabo', 'Jiquiriçá', 'Jitaúna', 'João Dourado', 'Juazeiro', 'Jucuruçu', 'Jussara', 'Jussari', 'Jussiape', 'Lafaiete Coutinho', 'Lagoa Real', 'Laje', 'Lajedinho', 'Lajedo do Tabocal', 'Lajedão', 'Lamarão', 'Lapão', 'Lauro de Freitas', 'Lençóis', 'Licínio de Almeida', 'Livramento de Nossa Senhora', 'Luís Eduardo Magalhães', 'Macajuba', 'Macarani', 'Macaúbas', 'Macururé', 'Madre de Deus', 'Maetinga', 'Maiquinique', 'Mairi', 'Malhada', 'Malhada de Pedras', 'Manoel Vitorino', 'Mansidão', 'Maracás', 'Maragogipe', 'Maraú', 'Marcionílio Souza', 'Mascote', 'Mata de São João', 'Matina', 'Medeiros Neto', 'Miguel Calmon', 'Milagres', 'Mirangaba', 'Mirante', 'Monte Santo', 'Morpará', 'Morro do Chapéu', 'Mortugaba', 'Mucugê', 'Mucuri', 'Mulungu do Morro', 'Mundo Novo', 'Muniz Ferreira', 'Muquém do São Francisco', 'Muritiba', 'Mutuípe', 'Nazaré', 'Nilo Peçanha', 'Nordestina', 'Nova Canaã', 'Nova Fátima', 'Nova Ibiá', 'Nova Itarana', 'Nova Redenção', 'Nova Soure', 'Nova Viçosa', 'Novo Horizonte', 'Novo Triunfo', 'Olindina', 'Oliveira dos Brejinhos', 'Ouriçangas', 'Ourolândia', 'Palmas de Monte Alto', 'Palmeiras', 'Paramirim', 'Paratinga', 'Paripiranga', 'Pau Brasil', 'Paulo Afonso', 'Pedro Alexandre', 'Pedrão', 'Piatã', 'Pilão Arcado', 'Pindaí', 'Pindobaçu', 'Pintadas', 'Piraí do Norte', 'Piripá', 'Piritiba', 'Planaltino', 'Planalto', 'Pojuca', 'Ponto Novo', 'Porto Seguro', 'Potiraguá', 'Poções', 'Prado', 'Presidente Dutra', 'Presidente Jânio Quadros', 'Presidente Tancredo Neves', 'Pé de Serra', 'Queimadas', 'Quijingue', 'Quixabeira', 'Rafael Jambeiro', 'Remanso', 'Retirolândia', 'Riacho de Santana', 'Riachão das Neves', 'Riachão do Jacuípe', 'Ribeira do Amparo', 'Ribeira do Pombal', 'Ribeirão do Largo', 'Rio Real', 'Rio de Contas', 'Rio do Antônio', 'Rio do Pires', 'Rodelas', 'Ruy Barbosa', 'Salinas da Margarida', 'Salvador', 'Santa Brígida', 'Santa Bárbara', 'Santa Cruz Cabrália', 'Santa Cruz da Vitória', 'Santa Inês', 'Santa Luzia', 'Santa Maria da Vitória', 'Santa Rita de Cássia', 'Santa Terezinha', 'Santaluz', 'Santana', 'Santanópolis', 'Santo Amaro', 'Santo Antônio de Jesus', 'Santo Estêvão', 'Sapeaçu', 'Saubara', 'Saúde', 'Seabra', 'Sebastião Laranjeiras', 'Senhor do Bonfim', 'Sento Sé', 'Serra Dourada', 'Serra Preta', 'Serra do Ramalho', 'Serrinha', 'Serrolândia', 'Simões Filho', 'Sobradinho', 'Souto Soares', 'Sátiro Dias', 'São Desidério', 'São Domingos', 'São Felipe', 'São Francisco do Conde', 'São Félix', 'São Félix do Coribe', 'São Gabriel', 'São Gonçalo dos Campos', 'São José da Vitória', 'São José do Jacuípe', 'São Miguel das Matas', 'São Sebastião do Passé', 'Sítio do Mato', 'Sítio do Quinto', 'Tabocas do Brejo Velho', 'Tanhaçu', 'Tanque Novo', 'Tanquinho', 'Taperoá', 'Tapiramutá', 'Teixeira de Freitas', 'Teodoro Sampaio', 'Teofilândia', 'Teolândia', 'Terra Nova', 'Tremedal', 'Tucano', 'Uauá', 'Ubaitaba', 'Ubatã', 'Ubaíra', 'Uibaí', 'Umburanas', 'Una', 'Urandi', 'Uruçuca', 'Utinga', 'Valente', 'Valença', 'Varzedo', 'Vera Cruz', 'Vereda', 'Vitória da Conquista', 'Várzea Nova', 'Várzea da Roça', 'Várzea do Poço', 'Wagner', 'Wanderley', 'Wenceslau Guimarães', 'Xique-Xique', 'Água Fria', 'Érico Cardoso'],
  PR: ['Abatiá', 'Adrianópolis', 'Agudos do Sul', 'Almirante Tamandaré', 'Altamira do Paraná', 'Alto Paraná', 'Alto Paraíso', 'Alto Piquiri', 'Altônia', 'Alvorada do Sul', 'Amaporã', 'Ampére', 'Anahy', 'Andirá', 'Antonina', 'Antônio Olinto', 'Apucarana', 'Arapongas', 'Arapoti', 'Arapuã', 'Araruna', 'Araucária', 'Ariranha do Ivaí', 'Assaí', 'Assis Chateaubriand', 'Astorga', 'Atalaia', 'Balsa Nova', 'Bandeirantes', 'Barbosa Ferraz', 'Barra do Jacaré', 'Barracão', 'Bela Vista da Caroba', 'Bela Vista do Paraíso', 'Bituruna', 'Boa Esperança', 'Boa Esperança do Iguaçu', 'Boa Ventura de São Roque', 'Boa Vista da Aparecida', 'Bocaiúva do Sul', 'Bom Jesus do Sul', 'Bom Sucesso', 'Bom Sucesso do Sul', 'Borrazópolis', 'Braganey', 'Brasilândia do Sul', 'Cafeara', 'Cafelândia', 'Cafezal do Sul', 'Califórnia', 'Cambará', 'Cambira', 'Cambé', 'Campina Grande do Sul', 'Campina da Lagoa', 'Campina do Simão', 'Campo Bonito', 'Campo Largo', 'Campo Magro', 'Campo Mourão', 'Campo do Tenente', 'Candói', 'Cantagalo', 'Capanema', 'Capitão Leônidas Marques', 'Carambeí', 'Carlópolis', 'Cascavel', 'Castro', 'Catanduvas', 'Centenário do Sul', 'Cerro Azul', 'Chopinzinho', 'Cianorte', 'Cidade Gaúcha', 'Clevelândia', 'Colombo', 'Colorado', 'Congonhinhas', 'Conselheiro Mairinck', 'Contenda', 'Corbélia', 'Cornélio Procópio', 'Coronel Domingos Soares', 'Coronel Vivida', 'Corumbataí do Sul', 'Cruz Machado', 'Cruzeiro do Iguaçu', 'Cruzeiro do Oeste', 'Cruzeiro do Sul', 'Cruzmaltina', 'Curitiba', 'Curiúva', 'Cândido de Abreu', 'Céu Azul', "Diamante D'Oeste", 'Diamante do Norte', 'Diamante do Sul', 'Dois Vizinhos', 'Douradina', 'Doutor Camargo', 'Doutor Ulysses', 'Engenheiro Beltrão', 'Entre Rios do Oeste', 'Enéas Marques', 'Esperança Nova', 'Espigão Alto do Iguaçu', 'Farol', 'Faxinal', 'Fazenda Rio Grande', 'Fernandes Pinheiro', 'Figueira', 'Flor da Serra do Sul', 'Floraí', 'Floresta', 'Florestópolis', 'Flórida', 'Formosa do Oeste', 'Foz do Iguaçu', 'Foz do Jordão', 'Francisco Alves', 'Francisco Beltrão', 'Fênix', 'General Carneiro', 'Godoy Moreira', 'Goioerê', 'Goioxim', 'Grandes Rios', 'Guairaçá', 'Guamiranga', 'Guapirama', 'Guaporema', 'Guaraci', 'Guaraniaçu', 'Guarapuava', 'Guaraqueçaba', 'Guaratuba', 'Guaíra', 'Honório Serpa', 'Ibaiti', 'Ibema', 'Ibiporã', 'Icaraíma', 'Iguaraçu', 'Iguatu', 'Imbaú', 'Imbituva', 'Inajá', 'Indianópolis', 'Inácio Martins', 'Ipiranga', 'Iporã', 'Iracema do Oeste', 'Irati', 'Iretama', 'Itaguajé', 'Itaipulândia', 'Itambaracá', 'Itambé', "Itapejara d'Oeste", 'Itaperuçu', 'Itaúna do Sul', 'Ivaiporã', 'Ivatuba', 'Ivaté', 'Ivaí', 'Jaboti', 'Jacarezinho', 'Jaguapitã', 'Jaguariaíva', 'Jandaia do Sul', 'Janiópolis', 'Japira', 'Japurá', 'Jardim Alegre', 'Jardim Olinda', 'Jataizinho', 'Jesuítas', 'Joaquim Távora', 'Jundiaí do Sul', 'Juranda', 'Jussara', 'Kaloré', 'Lapa', 'Laranjal', 'Laranjeiras do Sul', 'Leópolis', 'Lidianópolis', 'Lindoeste', 'Loanda', 'Lobato', 'Londrina', 'Luiziana', 'Lunardelli', 'Lupionópolis', 'Mallet', 'Mamborê', 'Mandaguari', 'Mandaguaçu', 'Mandirituba', 'Manfrinópolis', 'Mangueirinha', 'Manoel Ribas', 'Marechal Cândido Rondon', 'Maria Helena', 'Marialva', 'Marilena', 'Mariluz', 'Marilândia do Sul', 'Maringá', 'Maripá', 'Mariópolis', 'Marmeleiro', 'Marquinho', 'Marumbi', 'Matelândia', 'Matinhos', 'Mato Rico', 'Mauá da Serra', 'Medianeira', 'Mercedes', 'Mirador', 'Miraselva', 'Missal', 'Moreira Sales', 'Morretes', 'Munhoz de Melo', 'Nossa Senhora das Graças', 'Nova Aliança do Ivaí', 'Nova América da Colina', 'Nova Aurora', 'Nova Cantu', 'Nova Esperança', 'Nova Esperança do Sudoeste', 'Nova Fátima', 'Nova Laranjeiras', 'Nova Londrina', 'Nova Olímpia', 'Nova Prata do Iguaçu', 'Nova Santa Bárbara', 'Nova Santa Rosa', 'Nova Tebas', 'Novo Itacolomi', 'Ortigueira', 'Ourizona', 'Ouro Verde do Oeste', 'Paiçandu', 'Palmas', 'Palmeira', 'Palmital', 'Palotina', 'Paranacity', 'Paranaguá', 'Paranapoema', 'Paranavaí', 'Paraíso do Norte', 'Pato Bragado', 'Pato Branco', 'Paula Freitas', 'Paulo Frontin', 'Peabiru', 'Perobal', 'Pinhais', 'Pinhal de São Bento', 'Pinhalão', 'Pinhão', 'Piraquara', 'Piraí do Sul', 'Pitanga', 'Pitangueiras', 'Piên', 'Planaltina do Paraná', 'Planalto', 'Ponta Grossa', 'Pontal do Paraná', 'Porecatu', 'Porto Amazonas', 'Porto Barreiro', 'Porto Rico', 'Porto Vitória', 'Prado Ferreira', 'Pranchita', 'Presidente Castelo Branco', 'Primeiro de Maio', 'Prudentópolis', 'Pérola', "Pérola d'Oeste", 'Quarto Centenário', 'Quatiguá', 'Quatro Barras', 'Quatro Pontes', 'Quedas do Iguaçu', 'Querência do Norte', 'Quinta do Sol', 'Quitandinha', 'Ramilândia', 'Rancho Alegre', "Rancho Alegre D'Oeste", 'Realeza', 'Rebouças', 'Renascença', 'Reserva', 'Reserva do Iguaçu', 'Ribeirão Claro', 'Ribeirão do Pinhal', 'Rio Azul', 'Rio Bom', 'Rio Bonito do Iguaçu', 'Rio Branco do Ivaí', 'Rio Branco do Sul', 'Rio Negro', 'Rolândia', 'Roncador', 'Rondon', 'Rosário do Ivaí', 'Sabáudia', 'Salgado Filho', 'Salto do Itararé', 'Salto do Lontra', 'Santa Amélia', 'Santa Cecília do Pavão', 'Santa Cruz de Monte Castelo', 'Santa Fé', 'Santa Helena', 'Santa Inês', 'Santa Isabel do Ivaí', 'Santa Izabel do Oeste', 'Santa Lúcia', 'Santa Maria do Oeste', 'Santa Mariana', 'Santa Mônica', 'Santa Tereza do Oeste', 'Santa Terezinha de Itaipu', 'Santana do Itararé', 'Santo Antônio da Platina', 'Santo Antônio do Caiuá', 'Santo Antônio do Paraíso', 'Santo Antônio do Sudoeste', 'Santo Inácio', 'Sapopema', 'Sarandi', 'Saudade do Iguaçu', 'Sengés', 'Serranópolis do Iguaçu', 'Sertaneja', 'Sertanópolis', 'Siqueira Campos', 'Sulina', 'São Carlos do Ivaí', 'São Jerônimo da Serra', "São Jorge d'Oeste", 'São Jorge do Ivaí', 'São Jorge do Patrocínio', 'São José da Boa Vista', 'São José das Palmeiras', 'São José dos Pinhais', 'São João', 'São João do Caiuá', 'São João do Ivaí', 'São João do Triunfo', 'São Manoel do Paraná', 'São Mateus do Sul', 'São Miguel do Iguaçu', 'São Pedro do Iguaçu', 'São Pedro do Ivaí', 'São Pedro do Paraná', 'São Sebastião da Amoreira', 'São Tomé', 'Tamarana', 'Tamboara', 'Tapejara', 'Tapira', 'Teixeira Soares', 'Telêmaco Borba', 'Terra Boa', 'Terra Rica', 'Terra Roxa', 'Tibagi', 'Tijucas do Sul', 'Toledo', 'Tomazina', 'Três Barras do Paraná', 'Tunas do Paraná', 'Tuneiras do Oeste', 'Tupãssi', 'Turvo', 'Ubiratã', 'Umuarama', 'Uniflor', 'União da Vitória', 'Uraí', 'Ventania', 'Vera Cruz do Oeste', 'Verê', 'Virmond', 'Vitorino', 'Wenceslau Braz', 'Xambrê', 'Ângulo'],
  SC: ['Abdon Batista', 'Abelardo Luz', 'Agrolândia', 'Agronômica', 'Alfredo Wagner', 'Alto Bela Vista', 'Anchieta', 'Angelina', 'Anita Garibaldi', 'Anitápolis', 'Antônio Carlos', 'Apiúna', 'Arabutã', 'Araquari', 'Araranguá', 'Armazém', 'Arroio Trinta', 'Arvoredo', 'Ascurra', 'Atalanta', 'Aurora', 'Balneário Arroio do Silva', 'Balneário Barra do Sul', 'Balneário Camboriú', 'Balneário Gaivota', 'Balneário Piçarras', 'Balneário Rincão', 'Bandeirante', 'Barra Bonita', 'Barra Velha', 'Bela Vista do Toldo', 'Belmonte', 'Benedito Novo', 'Biguaçu', 'Blumenau', 'Bocaina do Sul', 'Bom Jardim da Serra', 'Bom Jesus', 'Bom Jesus do Oeste', 'Bom Retiro', 'Bombinhas', 'Botuverá', 'Braço do Norte', 'Braço do Trombudo', 'Brunópolis', 'Brusque', 'Caibi', 'Calmon', 'Camboriú', 'Campo Alegre', 'Campo Belo do Sul', 'Campo Erê', 'Campos Novos', 'Canelinha', 'Canoinhas', 'Capinzal', 'Capivari de Baixo', 'Capão Alto', 'Catanduvas', 'Caxambu do Sul', 'Caçador', 'Celso Ramos', 'Cerro Negro', 'Chapadão do Lageado', 'Chapecó', 'Cocal do Sul', 'Concórdia', 'Cordilheira Alta', 'Coronel Freitas', 'Coronel Martins', 'Correia Pinto', 'Corupá', 'Criciúma', 'Cunha Porã', 'Cunhataí', 'Curitibanos', 'Descanso', 'Dionísio Cerqueira', 'Dona Emma', 'Doutor Pedrinho', 'Entre Rios', 'Ermo', 'Erval Velho', 'Faxinal dos Guedes', 'Flor do Sertão', 'Florianópolis', 'Formosa do Sul', 'Forquilhinha', 'Fraiburgo', 'Frei Rogério', 'Galvão', 'Garopaba', 'Garuva', 'Gaspar', 'Governador Celso Ramos', 'Gravatal', 'Grão Pará', 'Guabiruba', 'Guaraciaba', 'Guaramirim', 'Guarujá do Sul', 'Guatambú', "Herval d'Oeste", 'Ibiam', 'Ibicaré', 'Ibirama', 'Ilhota', 'Imaruí', 'Imbituba', 'Imbuia', 'Indaial', 'Iomerê', 'Ipira', 'Iporã do Oeste', 'Ipuaçu', 'Ipumirim', 'Iraceminha', 'Irani', 'Irati', 'Irineópolis', 'Itaiópolis', 'Itajaí', 'Itapema', 'Itapiranga', 'Itapoá', 'Ituporanga', 'Itá', 'Içara', 'Jaborá', 'Jacinto Machado', 'Jaguaruna', 'Jaraguá do Sul', 'Jardinópolis', 'Joaçaba', 'Joinville', 'José Boiteux', 'Jupiá', 'Lacerdópolis', 'Lages', 'Laguna', 'Lajeado Grande', 'Laurentino', 'Lauro Müller', 'Lebon Régis', 'Leoberto Leal', 'Lindóia do Sul', 'Lontras', 'Luiz Alves', 'Luzerna', 'Macieira', 'Mafra', 'Major Gercino', 'Major Vieira', 'Maracajá', 'Maravilha', 'Marema', 'Massaranduba', 'Matos Costa', 'Meleiro', 'Mirim Doce', 'Modelo', 'Mondaí', 'Monte Carlo', 'Monte Castelo', 'Morro Grande', 'Morro da Fumaça', 'Navegantes', 'Nova Erechim', 'Nova Itaberaba', 'Nova Trento', 'Nova Veneza', 'Novo Horizonte', 'Orleans', 'Otacílio Costa', 'Ouro', 'Ouro Verde', 'Paial', 'Painel', 'Palhoça', 'Palma Sola', 'Palmeira', 'Palmitos', 'Papanduva', 'Paraíso', 'Passo de Torres', 'Passos Maia', 'Paulo Lopes', 'Pedras Grandes', 'Penha', 'Peritiba', 'Pescaria Brava', 'Petrolândia', 'Pinhalzinho', 'Pinheiro Preto', 'Piratuba', 'Planalto Alegre', 'Pomerode', 'Ponte Alta', 'Ponte Alta do Norte', 'Ponte Serrada', 'Porto Belo', 'Porto União', 'Pouso Redondo', 'Praia Grande', 'Presidente Castello Branco', 'Presidente Getúlio', 'Presidente Nereu', 'Princesa', 'Quilombo', 'Rancho Queimado', 'Rio Fortuna', 'Rio Negrinho', 'Rio Rufino', 'Rio das Antas', 'Rio do Campo', 'Rio do Oeste', 'Rio do Sul', 'Rio dos Cedros', 'Riqueza', 'Rodeio', 'Romelândia', 'Salete', 'Saltinho', 'Salto Veloso', 'Sangão', 'Santa Cecília', 'Santa Helena', 'Santa Rosa de Lima', 'Santa Rosa do Sul', 'Santa Terezinha', 'Santa Terezinha do Progresso', 'Santiago do Sul', 'Santo Amaro da Imperatriz', 'Saudades', 'Schroeder', 'Seara', 'Serra Alta', 'Siderópolis', 'Sombrio', 'Sul Brasil', 'São Bento do Sul', 'São Bernardino', 'São Bonifácio', 'São Carlos', 'São Cristóvão do Sul', 'São Domingos', 'São Francisco do Sul', 'São Joaquim', 'São José', 'São José do Cedro', 'São José do Cerrito', 'São João Batista', 'São João do Itaperiú', 'São João do Oeste', 'São João do Sul', 'São Lourenço do Oeste', 'São Ludgero', 'São Martinho', 'São Miguel da Boa Vista', 'São Miguel do Oeste', 'São Pedro de Alcântara', 'Taió', 'Tangará', 'Tigrinhos', 'Tijucas', 'Timbé do Sul', 'Timbó', 'Timbó Grande', 'Treviso', 'Treze Tílias', 'Treze de Maio', 'Trombudo Central', 'Três Barras', 'Tubarão', 'Tunápolis', 'Turvo', 'União do Oeste', 'Urubici', 'Urupema', 'Urussanga', 'Vargem', 'Vargem Bonita', 'Vargeão', 'Vidal Ramos', 'Videira', 'Vitor Meireles', 'Witmarsum', 'Xanxerê', 'Xavantina', 'Xaxim', 'Zortéa', 'Água Doce', 'Águas Frias', 'Águas Mornas', 'Águas de Chapecó'],
  PE: ['Abreu e Lima', 'Afogados da Ingazeira', 'Afrânio', 'Agrestina', 'Alagoinha', 'Aliança', 'Altinho', 'Amaraji', 'Angelim', 'Araripina', 'Araçoiaba', 'Arcoverde', 'Barra de Guabiraba', 'Barreiros', 'Belo Jardim', 'Belém de Maria', 'Belém do São Francisco', 'Betânia', 'Bezerros', 'Bodocó', 'Bom Conselho', 'Bom Jardim', 'Bonito', 'Brejinho', 'Brejo da Madre de Deus', 'Brejão', 'Buenos Aires', 'Buíque', 'Cabo de Santo Agostinho', 'Cabrobó', 'Cachoeirinha', 'Caetés', 'Calumbi', 'Calçado', 'Camaragibe', 'Camocim de São Félix', 'Camutanga', 'Canhotinho', 'Capoeiras', 'Carnaubeira da Penha', 'Carnaíba', 'Carpina', 'Caruaru', 'Casinhas', 'Catende', 'Cedro', 'Chã Grande', 'Chã de Alegria', 'Condado', 'Correntes', 'Cortês', 'Cumaru', 'Cupira', 'Custódia', 'Dormentes', 'Escada', 'Exu', 'Feira Nova', 'Fernando de Noronha', 'Ferreiros', 'Flores', 'Floresta', 'Frei Miguelinho', 'Gameleira', 'Garanhuns', 'Glória do Goitá', 'Goiana', 'Granito', 'Gravatá', 'Iati', 'Ibimirim', 'Ibirajuba', 'Igarassu', 'Iguaracy', 'Ilha de Itamaracá', 'Inajá', 'Ingazeira', 'Ipojuca', 'Ipubi', 'Itacuruba', 'Itambé', 'Itapetim', 'Itapissuma', 'Itaquitinga', 'Itaíba', 'Jaboatão dos Guararapes', 'Jaqueira', 'Jataúba', 'Jatobá', 'Joaquim Nabuco', 'João Alfredo', 'Jucati', 'Jupi', 'Jurema', 'Lagoa Grande', 'Lagoa de Itaenga', 'Lagoa do Carro', 'Lagoa do Ouro', 'Lagoa dos Gatos', 'Lajedo', 'Limoeiro', 'Macaparana', 'Machados', 'Manari', 'Maraial', 'Mirandiba', 'Moreilândia', 'Moreno', 'Nazaré da Mata', 'Olinda', 'Orobó', 'Orocó', 'Ouricuri', 'Palmares', 'Palmeirina', 'Panelas', 'Paranatama', 'Parnamirim', 'Passira', 'Paudalho', 'Paulista', 'Pedra', 'Pesqueira', 'Petrolina', 'Petrolândia', 'Pombos', 'Poção', 'Primavera', 'Quipapá', 'Quixaba', 'Recife', 'Riacho das Almas', 'Ribeirão', 'Rio Formoso', 'Sairé', 'Salgadinho', 'Salgueiro', 'Saloá', 'Sanharó', 'Santa Cruz', 'Santa Cruz da Baixa Verde', 'Santa Cruz do Capibaribe', 'Santa Filomena', 'Santa Maria da Boa Vista', 'Santa Maria do Cambucá', 'Santa Terezinha', 'Serra Talhada', 'Serrita', 'Sertânia', 'Sirinhaém', 'Solidão', 'Surubim', 'São Benedito do Sul', 'São Bento do Una', 'São Caitano', 'São Joaquim do Monte', 'São José da Coroa Grande', 'São José do Belmonte', 'São José do Egito', 'São João', 'São Lourenço da Mata', 'São Vicente Férrer', 'Tabira', 'Tacaimbó', 'Tacaratu', 'Tamandaré', 'Taquaritinga do Norte', 'Terezinha', 'Terra Nova', 'Timbaúba', 'Toritama', 'Tracunhaém', 'Trindade', 'Triunfo', 'Tupanatinga', 'Tuparetama', 'Venturosa', 'Verdejante', 'Vertente do Lério', 'Vertentes', 'Vicência', 'Vitória de Santo Antão', 'Xexéu', 'Água Preta', 'Águas Belas'],
  TO: ['Abreulândia', 'Aguiarnópolis', 'Aliança do Tocantins', 'Almas', 'Alvorada', 'Ananás', 'Angico', 'Aparecida do Rio Negro', 'Aragominas', 'Araguacema', 'Araguanã', 'Araguatins', 'Araguaçu', 'Araguaína', 'Arapoema', 'Arraias', 'Augustinópolis', 'Aurora do Tocantins', 'Axixá do Tocantins', 'Babaçulândia', 'Bandeirantes do Tocantins', 'Barra do Ouro', 'Barrolândia', 'Bernardo Sayão', 'Bom Jesus do Tocantins', 'Brasilândia do Tocantins', 'Brejinho de Nazaré', 'Buriti do Tocantins', 'Cachoeirinha', 'Campos Lindos', 'Cariri do Tocantins', 'Carmolândia', 'Carrasco Bonito', 'Caseara', 'Centenário', 'Chapada da Natividade', 'Chapada de Areia', 'Colinas do Tocantins', 'Colméia', 'Combinado', 'Conceição do Tocantins', 'Couto Magalhães', 'Cristalândia', 'Crixás do Tocantins', 'Darcinópolis', 'Dianópolis', 'Divinópolis do Tocantins', 'Dois Irmãos do Tocantins', 'Dueré', 'Esperantina', 'Figueirópolis', 'Filadélfia', 'Formoso do Araguaia', 'Fátima', 'Goianorte', 'Goiatins', 'Guaraí', 'Gurupi', 'Ipueiras', 'Itacajá', 'Itaguatins', 'Itapiratins', 'Itaporã do Tocantins', 'Jaú do Tocantins', 'Juarina', 'Lagoa da Confusão', 'Lagoa do Tocantins', 'Lajeado', 'Lavandeira', 'Lizarda', 'Luzinópolis', 'Marianópolis do Tocantins', 'Mateiros', 'Maurilândia do Tocantins', 'Miracema do Tocantins', 'Miranorte', 'Monte Santo do Tocantins', 'Monte do Carmo', 'Muricilândia', 'Natividade', 'Nazaré', 'Nova Olinda', 'Nova Rosalândia', 'Novo Acordo', 'Novo Alegre', 'Novo Jardim', 'Oliveira de Fátima', 'Palmas', 'Palmeirante', 'Palmeiras do Tocantins', 'Palmeirópolis', 'Paranã', 'Paraíso do Tocantins', "Pau D'Arco", 'Pedro Afonso', 'Peixe', 'Pequizeiro', 'Pindorama do Tocantins', 'Piraquê', 'Pium', 'Ponte Alta do Bom Jesus', 'Ponte Alta do Tocantins', 'Porto Alegre do Tocantins', 'Porto Nacional', 'Praia Norte', 'Presidente Kennedy', 'Pugmil', 'Recursolândia', 'Riachinho', 'Rio Sono', 'Rio da Conceição', 'Rio dos Bois', 'Sampaio', 'Sandolândia', 'Santa Fé do Araguaia', 'Santa Maria do Tocantins', 'Santa Rita do Tocantins', 'Santa Rosa do Tocantins', 'Santa Tereza do Tocantins', 'Santa Terezinha do Tocantins', 'Silvanópolis', 'Sucupira', 'São Bento do Tocantins', 'São Félix do Tocantins', 'São Miguel do Tocantins', 'São Salvador do Tocantins', 'São Sebastião do Tocantins', 'São Valério', 'Sítio Novo do Tocantins', 'Tabocão', 'Taguatinga', 'Taipas do Tocantins', 'Talismã', 'Tocantinópolis', 'Tocantínia', 'Tupirama', 'Tupiratins', 'Wanderlândia', 'Xambioá'],
  RN: ['Acari', 'Afonso Bezerra', 'Alexandria', 'Almino Afonso', 'Alto do Rodrigues', 'Angicos', 'Antônio Martins', 'Apodi', 'Areia Branca', 'Arês', 'Açu', 'Baraúna', 'Barcelona', 'Baía Formosa', 'Bento Fernandes', 'Bodó', 'Bom Jesus', 'Brejinho', 'Caicó', 'Caiçara do Norte', 'Caiçara do Rio do Vento', 'Campo Grande', 'Campo Redondo', 'Canguaretama', 'Caraúbas', 'Carnaubais', 'Carnaúba dos Dantas', 'Ceará-Mirim', 'Cerro Corá', 'Coronel Ezequiel', 'Coronel João Pessoa', 'Cruzeta', 'Currais Novos', 'Doutor Severiano', 'Encanto', 'Equador', 'Espírito Santo', 'Extremoz', 'Felipe Guerra', 'Fernando Pedroza', 'Florânia', 'Francisco Dantas', 'Frutuoso Gomes', 'Galinhos', 'Goianinha', 'Governador Dix-Sept Rosado', 'Grossos', 'Guamaré', 'Ielmo Marinho', 'Ipanguaçu', 'Ipueira', 'Itajá', 'Itaú', 'Jandaíra', 'Janduís', 'Januário Cicco', 'Japi', 'Jardim de Angicos', 'Jardim de Piranhas', 'Jardim do Seridó', 'Jaçanã', 'José da Penha', 'João Câmara', 'João Dias', 'Jucurutu', 'Jundiá', 'Lagoa Nova', 'Lagoa Salgada', "Lagoa d'Anta", 'Lagoa de Pedras', 'Lagoa de Velhos', 'Lajes', 'Lajes Pintadas', 'Lucrécia', 'Luís Gomes', 'Macau', 'Macaíba', 'Major Sales', 'Marcelino Vieira', 'Martins', 'Maxaranguape', 'Messias Targino', 'Montanhas', 'Monte Alegre', 'Monte das Gameleiras', 'Mossoró', 'Natal', 'Nova Cruz', 'Nísia Floresta', "Olho d'Água do Borges", 'Ouro Branco', 'Paraná', 'Parazinho', 'Paraú', 'Parelhas', 'Parnamirim', 'Passa e Fica', 'Passagem', 'Patu', 'Pau dos Ferros', 'Pedra Grande', 'Pedra Preta', 'Pedro Avelino', 'Pedro Velho', 'Pendências', 'Pilões', 'Portalegre', 'Porto do Mangue', 'Poço Branco', 'Pureza', 'Rafael Fernandes', 'Rafael Godeiro', 'Riacho da Cruz', 'Riacho de Santana', 'Riachuelo', 'Rio do Fogo', 'Rodolfo Fernandes', 'Ruy Barbosa', 'Santa Cruz', 'Santa Maria', 'Santana do Matos', 'Santana do Seridó', 'Santo Antônio', 'Senador Elói de Souza', 'Senador Georgino Avelino', 'Serra Caiada', 'Serra Negra do Norte', 'Serra de São Bento', 'Serra do Mel', 'Serrinha', 'Serrinha dos Pintos', 'Severiano Melo', 'São Bento do Norte', 'São Bento do Trairí', 'São Fernando', 'São Francisco do Oeste', 'São Gonçalo do Amarante', 'São José de Mipibu', 'São José do Campestre', 'São José do Seridó', 'São João do Sabugi', 'São Miguel', 'São Miguel do Gostoso', 'São Paulo do Potengi', 'São Pedro', 'São Rafael', 'São Tomé', 'São Vicente', 'Sítio Novo', 'Taboleiro Grande', 'Taipu', 'Tangará', 'Tenente Ananias', 'Tenente Laurentino Cruz', 'Tibau', 'Tibau do Sul', 'Timbaúba dos Batistas', 'Touros', 'Triunfo Potiguar', 'Umarizal', 'Upanema', 'Venha-Ver', 'Vera Cruz', 'Vila Flor', 'Viçosa', 'Várzea', 'Água Nova'],
  PI: ['Acauã', 'Agricolândia', 'Alagoinha do Piauí', 'Alegrete do Piauí', 'Alto Longá', 'Altos', 'Alvorada do Gurguéia', 'Amarante', 'Angical do Piauí', 'Antônio Almeida', 'Anísio de Abreu', 'Aroazes', 'Aroeiras do Itaim', 'Arraial', 'Assunção do Piauí', 'Avelino Lopes', 'Baixa Grande do Ribeiro', "Barra D'Alcântara", 'Barras', 'Barreiras do Piauí', 'Barro Duro', 'Batalha', 'Bela Vista do Piauí', 'Belém do Piauí', 'Beneditinos', 'Bertolínia', 'Betânia do Piauí', 'Boa Hora', 'Bocaina', 'Bom Jesus', 'Bom Princípio do Piauí', 'Bonfim do Piauí', 'Boqueirão do Piauí', 'Brasileira', 'Brejo do Piauí', 'Buriti dos Lopes', 'Buriti dos Montes', 'Cabeceiras do Piauí', 'Cajazeiras do Piauí', 'Cajueiro da Praia', 'Caldeirão Grande do Piauí', 'Campinas do Piauí', 'Campo Alegre do Fidalgo', 'Campo Grande do Piauí', 'Campo Largo do Piauí', 'Campo Maior', 'Canavieira', 'Canto do Buriti', 'Capitão Gervásio Oliveira', 'Capitão de Campos', 'Caracol', 'Caraúbas do Piauí', 'Caridade do Piauí', 'Castelo do Piauí', 'Caxingó', 'Cocal', 'Cocal de Telha', 'Cocal dos Alves', 'Coivaras', 'Colônia do Gurguéia', 'Colônia do Piauí', 'Conceição do Canindé', 'Coronel José Dias', 'Corrente', 'Cristalândia do Piauí', 'Cristino Castro', 'Curimatá', 'Currais', 'Curral Novo do Piauí', 'Curralinhos', 'Demerval Lobão', 'Dirceu Arcoverde', 'Dom Expedito Lopes', 'Dom Inocêncio', 'Domingos Mourão', 'Elesbão Veloso', 'Eliseu Martins', 'Esperantina', 'Fartura do Piauí', 'Flores do Piauí', 'Floresta do Piauí', 'Floriano', 'Francinópolis', 'Francisco Ayres', 'Francisco Macedo', 'Francisco Santos', 'Fronteiras', 'Geminiano', 'Gilbués', 'Guadalupe', 'Guaribas', 'Hugo Napoleão', 'Ilha Grande', 'Inhuma', 'Ipiranga do Piauí', 'Isaías Coelho', 'Itainópolis', 'Itaueira', 'Jacobina do Piauí', 'Jaicós', 'Jardim do Mulato', 'Jatobá do Piauí', 'Jerumenha', 'Joaquim Pires', 'Joca Marques', 'José de Freitas', 'João Costa', 'Juazeiro do Piauí', 'Jurema', 'Júlio Borges', 'Lagoa Alegre', 'Lagoa de São Francisco', 'Lagoa do Barro do Piauí', 'Lagoa do Piauí', 'Lagoa do Sítio', 'Lagoinha do Piauí', 'Landri Sales', 'Luzilândia', 'Luís Correia', 'Madeiro', 'Manoel Emídio', 'Marcolândia', 'Marcos Parente', 'Massapê do Piauí', 'Matias Olímpio', 'Miguel Alves', 'Miguel Leão', 'Milton Brandão', 'Monsenhor Gil', 'Monsenhor Hipólito', 'Monte Alegre do Piauí', 'Morro Cabeça no Tempo', 'Morro do Chapéu do Piauí', 'Murici dos Portelas', 'Nazaré do Piauí', 'Nazária', 'Nossa Senhora de Nazaré', 'Nossa Senhora dos Remédios', 'Nova Santa Rita', 'Novo Oriente do Piauí', 'Novo Santo Antônio', 'Oeiras', "Olho D'Água do Piauí", 'Padre Marcos', 'Paes Landim', 'Pajeú do Piauí', 'Palmeira do Piauí', 'Palmeirais', 'Paquetá', 'Parnaguá', 'Parnaíba', 'Passagem Franca do Piauí', 'Patos do Piauí', "Pau D'Arco do Piauí", 'Paulistana', 'Pavussu', 'Pedro II', 'Pedro Laurentino', 'Picos', 'Pimenteiras', 'Pio IX', 'Piracuruca', 'Piripiri', 'Porto', 'Porto Alegre do Piauí', 'Prata do Piauí', 'Queimada Nova', 'Redenção do Gurguéia', 'Regeneração', 'Riacho Frio', 'Ribeira do Piauí', 'Ribeiro Gonçalves', 'Rio Grande do Piauí', 'Santa Cruz do Piauí', 'Santa Cruz dos Milagres', 'Santa Filomena', 'Santa Luz', 'Santa Rosa do Piauí', 'Santana do Piauí', 'Santo Antônio de Lisboa', 'Santo Antônio dos Milagres', 'Santo Inácio do Piauí', 'Sebastião Barros', 'Sebastião Leal', 'Sigefredo Pacheco', 'Simplício Mendes', 'Simões', 'Socorro do Piauí', 'Sussuapara', 'São Braz do Piauí', 'São Francisco de Assis do Piauí', 'São Francisco do Piauí', 'São Félix do Piauí', 'São Gonçalo do Gurguéia', 'São Gonçalo do Piauí', 'São José do Divino', 'São José do Peixe', 'São José do Piauí', 'São João da Canabrava', 'São João da Fronteira', 'São João da Serra', 'São João da Varjota', 'São João do Arraial', 'São João do Piauí', 'São Julião', 'São Lourenço do Piauí', 'São Luis do Piauí', 'São Miguel da Baixa Grande', 'São Miguel do Fidalgo', 'São Miguel do Tapuio', 'São Pedro do Piauí', 'São Raimundo Nonato', 'Tamboril do Piauí', 'Tanque do Piauí', 'Teresina', 'União', 'Uruçuí', 'Valença do Piauí', 'Vera Mendes', 'Vila Nova do Piauí', 'Várzea Branca', 'Várzea Grande', 'Wall Ferraz', 'Água Branca'],
  RS: ['Aceguá', 'Agudo', 'Ajuricaba', 'Alecrim', 'Alegrete', 'Alegria', 'Almirante Tamandaré do Sul', 'Alpestre', 'Alto Alegre', 'Alto Feliz', 'Alvorada', 'Amaral Ferrador', 'Ametista do Sul', 'André da Rocha', 'Anta Gorda', 'Antônio Prado', 'Arambaré', 'Araricá', 'Aratiba', 'Arroio Grande', 'Arroio do Meio', 'Arroio do Padre', 'Arroio do Sal', 'Arroio do Tigre', 'Arroio dos Ratos', 'Arvorezinha', 'Augusto Pestana', 'Bagé', 'Balneário Pinhal', 'Barra Funda', 'Barra do Guarita', 'Barra do Quaraí', 'Barra do Ribeiro', 'Barra do Rio Azul', 'Barracão', 'Barros Cassal', 'Barão', 'Barão de Cotegipe', 'Barão do Triunfo', 'Benjamin Constant do Sul', 'Bento Gonçalves', 'Boa Vista das Missões', 'Boa Vista do Buricá', 'Boa Vista do Cadeado', 'Boa Vista do Incra', 'Boa Vista do Sul', 'Bom Jesus', 'Bom Princípio', 'Bom Progresso', 'Bom Retiro do Sul', 'Boqueirão do Leão', 'Bossoroca', 'Bozano', 'Braga', 'Brochier', 'Butiá', 'Cacequi', 'Cachoeira do Sul', 'Cachoeirinha', 'Cacique Doble', 'Caibaté', 'Caiçara', 'Camaquã', 'Camargo', 'Cambará do Sul', 'Campestre da Serra', 'Campina das Missões', 'Campinas do Sul', 'Campo Bom', 'Campo Novo', 'Campos Borges', 'Candelária', 'Candiota', 'Canela', 'Canguçu', 'Canoas', 'Canudos do Vale', 'Capela de Santana', 'Capitão', 'Capivari do Sul', 'Capão Bonito do Sul', 'Capão da Canoa', 'Capão do Cipó', 'Capão do Leão', 'Carazinho', 'Caraá', 'Carlos Barbosa', 'Carlos Gomes', 'Casca', 'Caseiros', 'Catuípe', 'Caxias do Sul', 'Caçapava do Sul', 'Centenário', 'Cerrito', 'Cerro Branco', 'Cerro Grande', 'Cerro Grande do Sul', 'Cerro Largo', 'Chapada', 'Charqueadas', 'Charrua', 'Chiapetta', 'Chuvisca', 'Chuí', 'Cidreira', 'Ciríaco', 'Colinas', 'Colorado', 'Condor', 'Constantina', 'Coqueiro Baixo', 'Coqueiros do Sul', 'Coronel Barros', 'Coronel Bicaco', 'Coronel Pilar', 'Cotiporã', 'Coxilha', 'Crissiumal', 'Cristal', 'Cristal do Sul', 'Cruz Alta', 'Cruzaltense', 'Cruzeiro do Sul', 'Cândido Godói', 'David Canabarro', 'Derrubadas', 'Dezesseis de Novembro', 'Dilermando de Aguiar', 'Dois Irmãos', 'Dois Irmãos das Missões', 'Dois Lajeados', 'Dom Feliciano', 'Dom Pedrito', 'Dom Pedro de Alcântara', 'Dona Francisca', 'Doutor Maurício Cardoso', 'Doutor Ricardo', 'Eldorado do Sul', 'Encantado', 'Encruzilhada do Sul', 'Engenho Velho', 'Entre Rios do Sul', 'Entre-Ijuís', 'Erebango', 'Erechim', 'Ernestina', 'Erval Grande', 'Erval Seco', 'Esmeralda', 'Esperança do Sul', 'Espumoso', 'Estação', 'Esteio', 'Estrela', 'Estrela Velha', 'Estância Velha', 'Eugênio de Castro', 'Fagundes Varela', 'Farroupilha', 'Faxinal do Soturno', 'Faxinalzinho', 'Fazenda Vilanova', 'Feliz', 'Flores da Cunha', 'Floriano Peixoto', 'Fontoura Xavier', 'Formigueiro', 'Forquetinha', 'Fortaleza dos Valos', 'Frederico Westphalen', 'Garibaldi', 'Garruchos', 'Gaurama', 'General Câmara', 'Gentil', 'Getúlio Vargas', 'Giruá', 'Glorinha', 'Gramado', 'Gramado Xavier', 'Gramado dos Loureiros', 'Gravataí', 'Guabiju', 'Guaporé', 'Guarani das Missões', 'Guaíba', 'Harmonia', 'Herval', 'Herveiras', 'Horizontina', 'Hulha Negra', 'Humaitá', 'Ibarama', 'Ibiaçá', 'Ibiraiaras', 'Ibirapuitã', 'Ibirubá', 'Igrejinha', 'Ijuí', 'Ilópolis', 'Imbé', 'Imigrante', 'Independência', 'Inhacorá', 'Ipiranga do Sul', 'Ipê', 'Iraí', 'Itaara', 'Itacurubi', 'Itapuca', 'Itaqui', 'Itati', 'Itatiba do Sul', 'Ivorá', 'Ivoti', 'Jaboticaba', 'Jacuizinho', 'Jacutinga', 'Jaguari', 'Jaguarão', 'Jaquirana', 'Jari', 'Jóia', 'Júlio de Castilhos', 'Lagoa Bonita do Sul', 'Lagoa Vermelha', 'Lagoa dos Três Cantos', 'Lagoão', 'Lajeado', 'Lajeado do Bugre', 'Lavras do Sul', 'Liberato Salzano', 'Lindolfo Collor', 'Linha Nova', 'Machadinho', 'Mampituba', 'Manoel Viana', 'Maquiné', 'Maratá', 'Marau', 'Marcelino Ramos', 'Mariana Pimentel', 'Mariano Moro', 'Marques de Souza', 'Mata', 'Mato Castelhano', 'Mato Leitão', 'Mato Queimado', 'Maximiliano de Almeida', 'Maçambará', 'Minas do Leão', 'Miraguaí', 'Montauri', 'Monte Alegre dos Campos', 'Monte Belo do Sul', 'Montenegro', 'Mormaço', 'Morrinhos do Sul', 'Morro Redondo', 'Morro Reuter', 'Mostardas', 'Muitos Capões', 'Muliterno', 'Muçum', 'Nicolau Vergueiro', 'Nonoai', 'Nova Alvorada', 'Nova Araçá', 'Nova Bassano', 'Nova Boa Vista', 'Nova Bréscia', 'Nova Candelária', 'Nova Esperança do Sul', 'Nova Hartz', 'Nova Palma', 'Nova Petrópolis', 'Nova Prata', 'Nova Pádua', 'Nova Ramada', 'Nova Roma do Sul', 'Nova Santa Rita', 'Novo Barreiro', 'Novo Cabrais', 'Novo Hamburgo', 'Novo Machado', 'Novo Tiradentes', 'Novo Xingu', 'Não-Me-Toque', 'Osório', 'Paim Filho', 'Palmares do Sul', 'Palmeira das Missões', 'Palmitinho', 'Panambi', 'Pantano Grande', 'Paraí', 'Paraíso do Sul', 'Pareci Novo', 'Parobé', 'Passa Sete', 'Passo Fundo', 'Passo do Sobrado', 'Paulo Bento', 'Paverama', 'Pedras Altas', 'Pedro Osório', 'Pejuçara', 'Pelotas', 'Picada Café', 'Pinhal', 'Pinhal Grande', 'Pinhal da Serra', 'Pinheirinho do Vale', 'Pinheiro Machado', 'Pinto Bandeira', 'Pirapó', 'Piratini', 'Planalto', 'Ponte Preta', 'Pontão', 'Porto Alegre', 'Porto Lucena', 'Porto Mauá', 'Porto Vera Cruz', 'Porto Xavier', 'Portão', 'Pouso Novo', 'Poço das Antas', 'Presidente Lucena', 'Progresso', 'Protásio Alves', 'Putinga', 'Quaraí', 'Quatro Irmãos', 'Quevedos', 'Quinze de Novembro', 'Redentora', 'Relvado', 'Restinga Sêca', 'Rio Grande', 'Rio Pardo', 'Rio dos Índios', 'Riozinho', 'Roca Sales', 'Rodeio Bonito', 'Rolador', 'Rolante', 'Ronda Alta', 'Rondinha', 'Roque Gonzales', 'Rosário do Sul', 'Sagrada Família', 'Saldanha Marinho', 'Salto do Jacuí', 'Salvador das Missões', 'Salvador do Sul', 'Sananduva', "Sant'Ana do Livramento", 'Santa Bárbara do Sul', 'Santa Cecília do Sul', 'Santa Clara do Sul', 'Santa Cruz do Sul', 'Santa Margarida do Sul', 'Santa Maria', 'Santa Maria do Herval', 'Santa Rosa', 'Santa Tereza', 'Santa Vitória do Palmar', 'Santana da Boa Vista', 'Santiago', 'Santo Antônio da Patrulha', 'Santo Antônio das Missões', 'Santo Antônio do Palma', 'Santo Antônio do Planalto', 'Santo Augusto', 'Santo Cristo', 'Santo Expedito do Sul', 'Santo Ângelo', 'Sapiranga', 'Sapucaia do Sul', 'Sarandi', 'Seberi', 'Sede Nova', 'Segredo', 'Selbach', 'Senador Salgado Filho', 'Sentinela do Sul', 'Serafina Corrêa', 'Sertão', 'Sertão Santana', 'Sete de Setembro', 'Severiano de Almeida', 'Silveira Martins', 'Sinimbu', 'Sobradinho', 'Soledade', 'São Borja', 'São Domingos do Sul', 'São Francisco de Assis', 'São Francisco de Paula', 'São Gabriel', 'São Jerônimo', 'São Jorge', 'São José das Missões', 'São José do Herval', 'São José do Hortêncio', 'São José do Inhacorá', 'São José do Norte', 'São José do Ouro', 'São José do Sul', 'São José dos Ausentes', 'São João da Urtiga', 'São João do Polêsine', 'São Leopoldo', 'São Lourenço do Sul', 'São Luiz Gonzaga', 'São Marcos', 'São Martinho', 'São Martinho da Serra', 'São Miguel das Missões', 'São Nicolau', 'São Paulo das Missões', 'São Pedro da Serra', 'São Pedro das Missões', 'São Pedro do Butiá', 'São Pedro do Sul', 'São Sebastião do Caí', 'São Sepé', 'São Valentim', 'São Valentim do Sul', 'São Valério do Sul', 'São Vendelino', 'São Vicente do Sul', 'Sério', 'Tabaí', 'Tapejara', 'Tapera', 'Tapes', 'Taquara', 'Taquari', 'Taquaruçu do Sul', 'Tavares', 'Tenente Portela', 'Terra de Areia', 'Teutônia', 'Tio Hugo', 'Tiradentes do Sul', 'Toropi', 'Torres', 'Tramandaí', 'Travesseiro', 'Trindade do Sul', 'Triunfo', 'Três Arroios', 'Três Cachoeiras', 'Três Coroas', 'Três Forquilhas', 'Três Palmeiras', 'Três Passos', 'Três de Maio', 'Tucunduva', 'Tunas', 'Tupanci do Sul', 'Tupanciretã', 'Tupandi', 'Tuparendi', 'Turuçu', 'Ubiretama', 'Unistalda', 'União da Serra', 'Uruguaiana', 'Vacaria', 'Vale Real', 'Vale Verde', 'Vale do Sol', 'Vanini', 'Venâncio Aires', 'Vera Cruz', 'Veranópolis', 'Vespasiano Corrêa', 'Viadutos', 'Viamão', 'Vicente Dutra', 'Victor Graeff', 'Vila Flores', 'Vila Lângaro', 'Vila Maria', 'Vila Nova do Sul', 'Vista Alegre', 'Vista Alegre do Prata', 'Vista Gaúcha', 'Vitória das Missões', 'Westfália', 'Xangri-lá', 'Água Santa', 'Áurea'],
  MT: ['Acorizal', 'Alta Floresta', 'Alto Araguaia', 'Alto Boa Vista', 'Alto Garças', 'Alto Paraguai', 'Alto Taquari', 'Apiacás', 'Araguaiana', 'Araguainha', 'Araputanga', 'Arenápolis', 'Aripuanã', 'Barra do Bugres', 'Barra do Garças', 'Barão de Melgaço', 'Bom Jesus do Araguaia', 'Brasnorte', 'Campinápolis', 'Campo Novo do Parecis', 'Campo Verde', 'Campos de Júlio', 'Canabrava do Norte', 'Canarana', 'Carlinda', 'Castanheira', 'Chapada dos Guimarães', 'Cláudia', 'Cocalinho', 'Colniza', 'Colíder', 'Comodoro', 'Confresa', "Conquista D'Oeste", 'Cotriguaçu', 'Cuiabá', 'Curvelândia', 'Cáceres', 'Denise', 'Diamantino', 'Dom Aquino', 'Feliz Natal', "Figueirópolis D'Oeste", 'Gaúcha do Norte', 'General Carneiro', "Glória D'Oeste", 'Guarantã do Norte', 'Guiratinga', 'Indiavaí', 'Ipiranga do Norte', 'Itanhangá', 'Itaúba', 'Itiquira', 'Jaciara', 'Jangada', 'Jauru', 'Juara', 'Juruena', 'Juscimeira', 'Juína', "Lambari D'Oeste", 'Lucas do Rio Verde', 'Luciara', 'Marcelândia', 'Matupá', "Mirassol d'Oeste", 'Nobres', 'Nortelândia', 'Nossa Senhora do Livramento', 'Nova Bandeirantes', 'Nova Brasilândia', 'Nova Canaã do Norte', 'Nova Guarita', 'Nova Lacerda', 'Nova Marilândia', 'Nova Maringá', 'Nova Monte Verde', 'Nova Mutum', 'Nova Nazaré', 'Nova Olímpia', 'Nova Santa Helena', 'Nova Ubiratã', 'Nova Xavantina', 'Novo Horizonte do Norte', 'Novo Mundo', 'Novo Santo Antônio', 'Novo São Joaquim', 'Paranatinga', 'Paranaíta', 'Pedra Preta', 'Peixoto de Azevedo', 'Planalto da Serra', 'Poconé', 'Pontal do Araguaia', 'Ponte Branca', 'Pontes e Lacerda', 'Porto Alegre do Norte', 'Porto Esperidião', 'Porto Estrela', 'Porto dos Gaúchos', 'Poxoréu', 'Primavera do Leste', 'Querência', 'Reserva do Cabaçal', 'Ribeirão Cascalheira', 'Ribeirãozinho', 'Rio Branco', 'Rondolândia', 'Rondonópolis', 'Rosário Oeste', 'Salto do Céu', 'Santa Carmem', 'Santa Cruz do Xingu', 'Santa Rita do Trivelato', 'Santa Terezinha', 'Santo Afonso', 'Santo Antônio do Leste', 'Santo Antônio do Leverger', 'Sapezal', 'Serra Nova Dourada', 'Sinop', 'Sorriso', 'São Félix do Araguaia', 'São José do Povo', 'São José do Rio Claro', 'São José do Xingu', 'São José dos Quatro Marcos', 'São Pedro da Cipa', 'Tabaporã', 'Tangará da Serra', 'Tapurah', 'Terra Nova do Norte', 'Tesouro', 'Torixoréu', 'União do Sul', 'Vale de São Domingos', 'Vera', 'Vila Bela da Santíssima Trindade', 'Vila Rica', 'Várzea Grande', 'Água Boa'],
  AC: ['Acrelândia', 'Assis Brasil', 'Brasiléia', 'Bujari', 'Capixaba', 'Cruzeiro do Sul', 'Epitaciolândia', 'Feijó', 'Jordão', 'Manoel Urbano', 'Marechal Thaumaturgo', 'Mâncio Lima', 'Plácido de Castro', 'Porto Acre', 'Porto Walter', 'Rio Branco', 'Rodrigues Alves', 'Santa Rosa do Purus', 'Sena Madureira', 'Senador Guiomard', 'Tarauacá', 'Xapuri'],
  SP: ['Adamantina', 'Adolfo', 'Aguaí', 'Agudos', 'Alambari', 'Alfredo Marcondes', 'Altair', 'Altinópolis', 'Alto Alegre', 'Alumínio', 'Alvinlândia', 'Americana', 'Amparo', 'Américo Brasiliense', 'Américo de Campos', 'Analândia', 'Andradina', 'Angatuba', 'Anhembi', 'Anhumas', 'Aparecida', "Aparecida d'Oeste", 'Apiaí', 'Aramina', 'Arandu', 'Arapeí', 'Araraquara', 'Araras', 'Araçariguama', 'Araçatuba', 'Araçoiaba da Serra', 'Arco-Íris', 'Arealva', 'Areias', 'Areiópolis', 'Ariranha', 'Artur Nogueira', 'Arujá', 'Aspásia', 'Assis', 'Atibaia', 'Auriflama', 'Avanhandava', 'Avaré', 'Avaí', 'Bady Bassitt', 'Balbinos', 'Bananal', 'Barbosa', 'Bariri', 'Barra Bonita', 'Barra do Chapéu', 'Barra do Turvo', 'Barretos', 'Barrinha', 'Barueri', 'Barão de Antonina', 'Bastos', 'Batatais', 'Bauru', 'Bebedouro', 'Bento de Abreu', 'Bernardino de Campos', 'Bertioga', 'Bilac', 'Birigui', 'Biritiba Mirim', 'Boa Esperança do Sul', 'Bocaina', 'Bofete', 'Boituva', 'Bom Jesus dos Perdões', 'Bom Sucesso de Itararé', 'Boracéia', 'Borborema', 'Borebi', 'Borá', 'Botucatu', 'Bragança Paulista', 'Braúna', 'Brejo Alegre', 'Brodowski', 'Brotas', 'Buri', 'Buritama', 'Buritizal', 'Bálsamo', 'Cabreúva', 'Cabrália Paulista', 'Cachoeira Paulista', 'Caconde', 'Cafelândia', 'Caiabu', 'Caieiras', 'Caiuá', 'Cajamar', 'Cajati', 'Cajobi', 'Cajuru', 'Campina do Monte Alegre', 'Campinas', 'Campo Limpo Paulista', 'Campos Novos Paulista', 'Campos do Jordão', 'Cananéia', 'Canas', 'Canitar', 'Capela do Alto', 'Capivari', 'Capão Bonito', 'Caraguatatuba', 'Carapicuíba', 'Cardoso', 'Casa Branca', 'Castilho', 'Catanduva', 'Catiguá', 'Caçapava', 'Cedral', 'Cerqueira César', 'Cerquilho', 'Cesário Lange', 'Charqueada', 'Chavantes', 'Clementina', 'Colina', 'Colômbia', 'Conchal', 'Conchas', 'Cordeirópolis', 'Coroados', 'Coronel Macedo', 'Corumbataí', 'Cosmorama', 'Cosmópolis', 'Cotia', 'Cravinhos', 'Cristais Paulista', 'Cruzeiro', 'Cruzália', 'Cubatão', 'Cunha', 'Cássia dos Coqueiros', 'Cândido Mota', 'Cândido Rodrigues', 'Descalvado', 'Diadema', 'Dirce Reis', 'Divinolândia', 'Dobrada', 'Dois Córregos', 'Dolcinópolis', 'Dourado', 'Dracena', 'Duartina', 'Dumont', 'Echaporã', 'Eldorado', 'Elias Fausto', 'Elisiário', 'Embaúba', 'Embu das Artes', 'Embu-Guaçu', 'Emilianópolis', 'Engenheiro Coelho', 'Espírito Santo do Pinhal', 'Espírito Santo do Turvo', 'Estiva Gerbi', "Estrela d'Oeste", 'Estrela do Norte', 'Euclides da Cunha Paulista', 'Fartura', 'Fernando Prestes', 'Fernandópolis', 'Fernão', 'Ferraz de Vasconcelos', 'Flora Rica', 'Floreal', 'Florínea', 'Flórida Paulista', 'Franca', 'Francisco Morato', 'Franco da Rocha', 'Gabriel Monteiro', 'Garça', 'Gastão Vidigal', 'Gavião Peixoto', 'General Salgado', 'Getulina', 'Glicério', 'Guaimbê', 'Guaiçara', 'Guapiara', 'Guapiaçu', 'Guaraci', "Guarani d'Oeste", 'Guarantã', 'Guararapes', 'Guararema', 'Guaratinguetá', 'Guaraçaí', 'Guareí', 'Guariba', 'Guarujá', 'Guarulhos', 'Guará', 'Guatapará', 'Guaíra', 'Guzolândia', 'Gália', 'Herculândia', 'Holambra', 'Hortolândia', 'Iacanga', 'Iacri', 'Iaras', 'Ibaté', 'Ibirarema', 'Ibirá', 'Ibitinga', 'Ibiúna', 'Icém', 'Iepê', 'Igarapava', 'Igaratá', 'Igaraçu do Tietê', 'Iguape', 'Ilha Comprida', 'Ilha Solteira', 'Ilhabela', 'Indaiatuba', 'Indiana', 'Indiaporã', 'Inúbia Paulista', 'Ipaussu', 'Iperó', 'Ipeúna', 'Ipiguá', 'Iporanga', 'Ipuã', 'Iracemápolis', 'Irapuru', 'Irapuã', 'Itaberá', 'Itajobi', 'Itaju', 'Itanhaém', 'Itaoca', 'Itapecerica da Serra', 'Itapetininga', 'Itapeva', 'Itapevi', 'Itapira', 'Itapirapuã Paulista', 'Itaporanga', 'Itapura', 'Itapuí', 'Itaquaquecetuba', 'Itararé', 'Itariri', 'Itatiba', 'Itatinga', 'Itaí', 'Itirapina', 'Itirapuã', 'Itobi', 'Itu', 'Itupeva', 'Ituverava', 'Itápolis', 'Jaborandi', 'Jaboticabal', 'Jacareí', 'Jaci', 'Jacupiranga', 'Jaguariúna', 'Jales', 'Jambeiro', 'Jandira', 'Jardinópolis', 'Jarinu', 'Jaú', 'Jeriquara', 'Joanópolis', 'José Bonifácio', 'João Ramalho', 'Jumirim', 'Jundiaí', 'Junqueirópolis', 'Juquitiba', 'Juquiá', 'Júlio Mesquita', 'Lagoinha', 'Laranjal Paulista', 'Lavrinhas', 'Lavínia', 'Leme', 'Lençóis Paulista', 'Limeira', 'Lindóia', 'Lins', 'Lorena', 'Lourdes', 'Louveira', 'Lucianópolis', 'Lucélia', 'Luiziânia', 'Lupércio', 'Lutécia', 'Luís Antônio', 'Macatuba', 'Macaubal', 'Macedônia', 'Magda', 'Mairinque', 'Mairiporã', 'Manduri', 'Marabá Paulista', 'Maracaí', 'Marapoama', 'Marinópolis', 'Mariápolis', 'Martinópolis', 'Marília', 'Matão', 'Mauá', 'Mendonça', 'Meridiano', 'Mesópolis', 'Miguelópolis', 'Mineiros do Tietê', 'Mira Estrela', 'Miracatu', 'Mirandópolis', 'Mirante do Paranapanema', 'Mirassol', 'Mirassolândia', 'Mococa', 'Mogi Guaçu', 'Mogi Mirim', 'Mogi das Cruzes', 'Mombuca', 'Mongaguá', 'Monte Alegre do Sul', 'Monte Alto', 'Monte Aprazível', 'Monte Azul Paulista', 'Monte Castelo', 'Monte Mor', 'Monteiro Lobato', 'Monções', 'Morro Agudo', 'Morungaba', 'Motuca', 'Murutinga do Sul', 'Nantes', 'Narandiba', 'Natividade da Serra', 'Nazaré Paulista', 'Neves Paulista', 'Nhandeara', 'Nipoã', 'Nova Aliança', 'Nova Campina', 'Nova Canaã Paulista', 'Nova Castilho', 'Nova Europa', 'Nova Granada', 'Nova Guataporanga', 'Nova Independência', 'Nova Luzitânia', 'Nova Odessa', 'Novais', 'Novo Horizonte', 'Nuporanga', 'Ocauçu', 'Olímpia', 'Onda Verde', 'Oriente', 'Orindiúva', 'Orlândia', 'Osasco', 'Oscar Bressane', 'Osvaldo Cruz', 'Ourinhos', 'Ouro Verde', 'Ouroeste', 'Pacaembu', 'Palestina', 'Palmares Paulista', "Palmeira d'Oeste", 'Palmital', 'Panorama', 'Paraguaçu Paulista', 'Paraibuna', 'Paranapanema', 'Paranapuã', 'Parapuã', 'Paraíso', 'Pardinho', 'Pariquera-Açu', 'Parisi', 'Patrocínio Paulista', 'Paulicéia', 'Paulistânia', 'Paulo de Faria', 'Paulínia', 'Pederneiras', 'Pedra Bela', 'Pedranópolis', 'Pedregulho', 'Pedreira', 'Pedrinhas Paulista', 'Pedro de Toledo', 'Penápolis', 'Pereira Barreto', 'Pereiras', 'Peruíbe', 'Piacatu', 'Piedade', 'Pilar do Sul', 'Pindamonhangaba', 'Pindorama', 'Pinhalzinho', 'Piquerobi', 'Piquete', 'Piracaia', 'Piracicaba', 'Piraju', 'Pirajuí', 'Pirangi', 'Pirapora do Bom Jesus', 'Pirapozinho', 'Pirassununga', 'Piratininga', 'Pitangueiras', 'Planalto', 'Platina', 'Poloni', 'Pompéia', 'Pongaí', 'Pontal', 'Pontalinda', 'Pontes Gestal', 'Populina', 'Porangaba', 'Porto Feliz', 'Porto Ferreira', 'Potim', 'Potirendaba', 'Poá', 'Pracinha', 'Pradópolis', 'Praia Grande', 'Pratânia', 'Presidente Alves', 'Presidente Bernardes', 'Presidente Epitácio', 'Presidente Prudente', 'Presidente Venceslau', 'Promissão', 'Quadra', 'Quatá', 'Queiroz', 'Queluz', 'Quintana', 'Rafard', 'Rancharia', 'Redenção da Serra', 'Regente Feijó', 'Reginópolis', 'Registro', 'Restinga', 'Ribeira', 'Ribeirão Bonito', 'Ribeirão Branco', 'Ribeirão Corrente', 'Ribeirão Grande', 'Ribeirão Pires', 'Ribeirão Preto', 'Ribeirão do Sul', 'Ribeirão dos Índios', 'Rifaina', 'Rincão', 'Rinópolis', 'Rio Claro', 'Rio Grande da Serra', 'Rio das Pedras', 'Riolândia', 'Riversul', 'Rosana', 'Roseira', 'Rubinéia', 'Rubiácea', 'Sabino', 'Sagres', 'Sales', 'Sales Oliveira', 'Salesópolis', 'Salmourão', 'Saltinho', 'Salto', 'Salto Grande', 'Salto de Pirapora', 'Sandovalina', 'Santa Adélia', 'Santa Albertina', 'Santa Branca', "Santa Bárbara d'Oeste", "Santa Clara d'Oeste", 'Santa Cruz da Conceição', 'Santa Cruz da Esperança', 'Santa Cruz das Palmeiras', 'Santa Cruz do Rio Pardo', 'Santa Ernestina', 'Santa Fé do Sul', 'Santa Gertrudes', 'Santa Isabel', 'Santa Lúcia', 'Santa Maria da Serra', 'Santa Mercedes', "Santa Rita d'Oeste", 'Santa Rita do Passa Quatro', 'Santa Rosa de Viterbo', 'Santa Salete', 'Santana da Ponte Pensa', 'Santana de Parnaíba', 'Santo Anastácio', 'Santo André', 'Santo Antônio da Alegria', 'Santo Antônio de Posse', 'Santo Antônio do Aracanguá', 'Santo Antônio do Jardim', 'Santo Antônio do Pinhal', 'Santo Expedito', 'Santos', 'Santópolis do Aguapeí', 'Sarapuí', 'Sarutaiá', 'Sebastianópolis do Sul', 'Serra Azul', 'Serra Negra', 'Serrana', 'Sertãozinho', 'Sete Barras', 'Severínia', 'Silveiras', 'Socorro', 'Sorocaba', 'Sud Mennucci', 'Sumaré', 'Suzano', 'Suzanápolis', 'São Bento do Sapucaí', 'São Bernardo do Campo', 'São Caetano do Sul', 'São Carlos', 'São Francisco', 'São Joaquim da Barra', 'São José da Bela Vista', 'São José do Barreiro', 'São José do Rio Pardo', 'São José do Rio Preto', 'São José dos Campos', 'São João da Boa Vista', 'São João das Duas Pontes', 'São João de Iracema', "São João do Pau d'Alho", 'São Lourenço da Serra', 'São Luiz do Paraitinga', 'São Manuel', 'São Miguel Arcanjo', 'São Paulo', 'São Pedro', 'São Pedro do Turvo', 'São Roque', 'São Sebastião', 'São Sebastião da Grama', 'São Simão', 'São Vicente', 'Tabapuã', 'Tabatinga', 'Taboão da Serra', 'Taciba', 'Taguaí', 'Taiaçu', 'Taiúva', 'Tambaú', 'Tanabi', 'Tapiratiba', 'Tapiraí', 'Taquaral', 'Taquaritinga', 'Taquarituba', 'Taquarivaí', 'Tarabai', 'Tarumã', 'Tatuí', 'Taubaté', 'Tejupá', 'Teodoro Sampaio', 'Terra Roxa', 'Tietê', 'Timburi', 'Torre de Pedra', 'Torrinha', 'Trabiju', 'Tremembé', 'Três Fronteiras', 'Tuiuti', 'Tupi Paulista', 'Tupã', 'Turiúba', 'Turmalina', 'Ubarana', 'Ubatuba', 'Ubirajara', 'Uchoa', 'União Paulista', 'Uru', 'Urupês', 'Urânia', 'Valentim Gentil', 'Valinhos', 'Valparaíso', 'Vargem', 'Vargem Grande Paulista', 'Vargem Grande do Sul', 'Vera Cruz', 'Vinhedo', 'Viradouro', 'Vista Alegre do Alto', 'Vitória Brasil', 'Votorantim', 'Votuporanga', 'Várzea Paulista', 'Zacarias', 'Águas da Prata', 'Águas de Lindóia', 'Águas de Santa Bárbara', 'Águas de São Pedro', 'Álvares Florence', 'Álvares Machado', 'Álvaro de Carvalho', 'Óleo'],
  ES: ['Afonso Cláudio', 'Alegre', 'Alfredo Chaves', 'Alto Rio Novo', 'Anchieta', 'Apiacá', 'Aracruz', 'Atílio Vivacqua', 'Baixo Guandu', 'Barra de São Francisco', 'Boa Esperança', 'Bom Jesus do Norte', 'Brejetuba', 'Cachoeiro de Itapemirim', 'Cariacica', 'Castelo', 'Colatina', 'Conceição da Barra', 'Conceição do Castelo', 'Divino de São Lourenço', 'Domingos Martins', 'Dores do Rio Preto', 'Ecoporanga', 'Fundão', 'Governador Lindenberg', 'Guarapari', 'Guaçuí', 'Ibatiba', 'Ibiraçu', 'Ibitirama', 'Iconha', 'Irupi', 'Itaguaçu', 'Itapemirim', 'Itarana', 'Iúna', 'Jaguaré', 'Jerônimo Monteiro', 'João Neiva', 'Laranja da Terra', 'Linhares', 'Mantenópolis', 'Marataízes', 'Marechal Floriano', 'Marilândia', 'Mimoso do Sul', 'Montanha', 'Mucurici', 'Muniz Freire', 'Muqui', 'Nova Venécia', 'Pancas', 'Pedro Canário', 'Pinheiros', 'Piúma', 'Ponto Belo', 'Presidente Kennedy', 'Rio Bananal', 'Rio Novo do Sul', 'Santa Leopoldina', 'Santa Maria de Jetibá', 'Santa Teresa', 'Serra', 'Sooretama', 'São Domingos do Norte', 'São Gabriel da Palha', 'São José do Calçado', 'São Mateus', 'São Roque do Canaã', 'Vargem Alta', 'Venda Nova do Imigrante', 'Viana', 'Vila Pavão', 'Vila Valério', 'Vila Velha', 'Vitória', 'Água Doce do Norte', 'Águia Branca'],
  MA: ['Afonso Cunha', 'Alcântara', 'Aldeias Altas', 'Altamira do Maranhão', 'Alto Alegre do Maranhão', 'Alto Alegre do Pindaré', 'Alto Parnaíba', 'Amapá do Maranhão', 'Amarante do Maranhão', 'Anajatuba', 'Anapurus', 'Apicum-Açu', 'Araguanã', 'Araioses', 'Arame', 'Arari', 'Axixá', 'Açailândia', 'Bacabal', 'Bacabeira', 'Bacuri', 'Bacurituba', 'Balsas', 'Barra do Corda', 'Barreirinhas', 'Barão de Grajaú', 'Bela Vista do Maranhão', 'Belágua', 'Benedito Leite', 'Bequimão', 'Bernardo do Mearim', 'Boa Vista do Gurupi', 'Bom Jardim', 'Bom Jesus das Selvas', 'Bom Lugar', 'Brejo', 'Brejo de Areia', 'Buriti', 'Buriti Bravo', 'Buriticupu', 'Buritirana', 'Cachoeira Grande', 'Cajapió', 'Cajari', 'Campestre do Maranhão', 'Cantanhede', 'Capinzal do Norte', 'Carolina', 'Carutapera', 'Caxias', 'Cedral', 'Central do Maranhão', 'Centro Novo do Maranhão', 'Centro do Guilherme', 'Chapadinha', 'Cidelândia', 'Codó', 'Coelho Neto', 'Colinas', 'Conceição do Lago-Açu', 'Coroatá', 'Cururupu', 'Cândido Mendes', 'Davinópolis', 'Dom Pedro', 'Duque Bacelar', 'Esperantinópolis', 'Estreito', 'Feira Nova do Maranhão', 'Fernando Falcão', 'Formosa da Serra Negra', 'Fortaleza dos Nogueiras', 'Fortuna', 'Godofredo Viana', 'Gonçalves Dias', 'Governador Archer', 'Governador Edison Lobão', 'Governador Eugênio Barros', 'Governador Luiz Rocha', 'Governador Newton Bello', 'Governador Nunes Freire', 'Grajaú', 'Graça Aranha', 'Guimarães', 'Humberto de Campos', 'Icatu', 'Igarapé Grande', 'Igarapé do Meio', 'Imperatriz', 'Itaipava do Grajaú', 'Itapecuru Mirim', 'Itinga do Maranhão', 'Jatobá', 'Jenipapo dos Vieiras', 'Joselândia', 'João Lisboa', 'Junco do Maranhão', 'Lago Verde', 'Lago da Pedra', 'Lago do Junco', 'Lago dos Rodrigues', 'Lagoa Grande do Maranhão', 'Lagoa do Mato', 'Lajeado Novo', 'Lima Campos', 'Loreto', 'Luís Domingues', 'Magalhães de Almeida', 'Maracaçumé', 'Marajá do Sena', 'Maranhãozinho', 'Mata Roma', 'Matinha', 'Matões', 'Matões do Norte', 'Milagres do Maranhão', 'Mirador', 'Miranda do Norte', 'Mirinzal', 'Montes Altos', 'Monção', 'Morros', 'Nina Rodrigues', 'Nova Colinas', 'Nova Iorque', 'Nova Olinda do Maranhão', "Olho d'Água das Cunhãs", 'Olinda Nova do Maranhão', 'Palmeirândia', 'Paraibano', 'Parnarama', 'Passagem Franca', 'Pastos Bons', 'Paulino Neves', 'Paulo Ramos', 'Paço do Lumiar', 'Pedreiras', 'Pedro do Rosário', 'Penalva', 'Peri Mirim', 'Peritoró', 'Pindaré-Mirim', 'Pinheiro', 'Pio XII', 'Pirapemas', 'Porto Franco', 'Porto Rico do Maranhão', 'Poção de Pedras', 'Presidente Dutra', 'Presidente Juscelino', 'Presidente Médici', 'Presidente Sarney', 'Presidente Vargas', 'Primeira Cruz', 'Raposa', 'Riachão', 'Ribamar Fiquene', 'Rosário', 'Sambaíba', 'Santa Filomena do Maranhão', 'Santa Helena', 'Santa Inês', 'Santa Luzia', 'Santa Luzia do Paruá', 'Santa Quitéria do Maranhão', 'Santa Rita', 'Santana do Maranhão', 'Santo Amaro do Maranhão', 'Santo Antônio dos Lopes', 'Satubinha', 'Senador Alexandre Costa', 'Senador La Rocque', 'Serrano do Maranhão', 'Sucupira do Norte', 'Sucupira do Riachão', 'São Benedito do Rio Preto', 'São Bento', 'São Bernardo', 'São Domingos do Azeitão', 'São Domingos do Maranhão', 'São Francisco do Brejão', 'São Francisco do Maranhão', 'São Félix de Balsas', 'São José de Ribamar', 'São José dos Basílios', 'São João Batista', 'São João do Carú', 'São João do Paraíso', 'São João do Soter', 'São João dos Patos', 'São Luís', 'São Luís Gonzaga do Maranhão', 'São Mateus do Maranhão', 'São Pedro da Água Branca', 'São Pedro dos Crentes', 'São Raimundo das Mangabeiras', 'São Raimundo do Doca Bezerra', 'São Roberto', 'São Vicente Ferrer', 'Sítio Novo', 'Tasso Fragoso', 'Timbiras', 'Timon', 'Trizidela do Vale', 'Tufilândia', 'Tuntum', 'Turiaçu', 'Turilândia', 'Tutóia', 'Urbano Santos', 'Vargem Grande', 'Viana', 'Vila Nova dos Martírios', 'Vitorino Freire', 'Vitória do Mearim', 'Zé Doca', 'Água Doce do Maranhão'],
  PB: ['Aguiar', 'Alagoa Grande', 'Alagoa Nova', 'Alagoinha', 'Alcantil', 'Algodão de Jandaíra', 'Alhandra', 'Amparo', 'Aparecida', 'Arara', 'Araruna', 'Araçagi', 'Areia', 'Areia de Baraúnas', 'Areial', 'Aroeiras', 'Assunção', 'Bananeiras', 'Baraúna', 'Barra de Santa Rosa', 'Barra de Santana', 'Barra de São Miguel', 'Bayeux', 'Baía da Traição', 'Belém', 'Belém do Brejo do Cruz', 'Bernardino Batista', 'Boa Ventura', 'Boa Vista', 'Bom Jesus', 'Bom Sucesso', 'Bonito de Santa Fé', 'Boqueirão', 'Borborema', 'Brejo do Cruz', 'Brejo dos Santos', 'Caaporã', 'Cabaceiras', 'Cabedelo', 'Cachoeira dos Índios', 'Cacimba de Areia', 'Cacimba de Dentro', 'Cacimbas', 'Caiçara', 'Cajazeiras', 'Cajazeirinhas', 'Caldas Brandão', 'Camalaú', 'Campina Grande', 'Capim', 'Caraúbas', 'Carrapateira', 'Casserengue', 'Catingueira', 'Catolé do Rocha', 'Caturité', 'Conceição', 'Condado', 'Conde', 'Congo', 'Coremas', 'Coxixola', 'Cruz do Espírito Santo', 'Cubati', 'Cuitegi', 'Cuité', 'Cuité de Mamanguape', 'Curral Velho', 'Curral de Cima', 'Damião', 'Desterro', 'Diamante', 'Dona Inês', 'Duas Estradas', 'Emas', 'Esperança', 'Fagundes', 'Frei Martinho', 'Gado Bravo', 'Guarabira', 'Gurinhém', 'Gurjão', 'Ibiara', 'Igaracy', 'Imaculada', 'Ingá', 'Itabaiana', 'Itaporanga', 'Itapororoca', 'Itatuba', 'Jacaraú', 'Jericó', 'Joca Claudino', 'João Pessoa', 'Juarez Távora', 'Juazeirinho', 'Junco do Seridó', 'Juripiranga', 'Juru', 'Lagoa', 'Lagoa Seca', 'Lagoa de Dentro', 'Lastro', 'Livramento', 'Logradouro', 'Lucena', 'Malta', 'Mamanguape', 'Manaíra', 'Marcação', 'Mari', 'Marizópolis', 'Massaranduba', 'Mataraca', 'Matinhas', 'Mato Grosso', 'Maturéia', 'Mogeiro', 'Montadas', 'Monte Horebe', 'Monteiro', 'Mulungu', "Mãe d'Água", 'Natuba', 'Nazarezinho', 'Nova Floresta', 'Nova Olinda', 'Nova Palmeira', "Olho d'Água", 'Olivedos', 'Ouro Velho', 'Parari', 'Passagem', 'Patos', 'Paulista', 'Pedra Branca', 'Pedra Lavrada', 'Pedras de Fogo', 'Pedro Régis', 'Piancó', 'Picuí', 'Pilar', 'Pilões', 'Pilõezinhos', 'Pirpirituba', 'Pitimbu', 'Pocinhos', 'Pombal', 'Poço Dantas', 'Poço de José de Moura', 'Prata', 'Princesa Isabel', 'Puxinanã', 'Queimadas', 'Quixaba', 'Remígio', 'Riacho de Santo Antônio', 'Riacho dos Cavalos', 'Riachão', 'Riachão do Bacamarte', 'Riachão do Poço', 'Rio Tinto', 'Salgadinho', 'Salgado de São Félix', 'Santa Cecília', 'Santa Cruz', 'Santa Helena', 'Santa Inês', 'Santa Luzia', 'Santa Rita', 'Santa Teresinha', 'Santana de Mangueira', 'Santana dos Garrotes', 'Santo André', 'Sapé', 'Serra Branca', 'Serra Grande', 'Serra Redonda', 'Serra da Raiz', 'Serraria', 'Sertãozinho', 'Sobrado', 'Soledade', 'Solânea', 'Sossêgo', 'Sousa', 'Sumé', 'São Bentinho', 'São Bento', 'São Domingos', 'São Domingos do Cariri', 'São Francisco', 'São José da Lagoa Tapada', 'São José de Caiana', 'São José de Espinharas', 'São José de Piranhas', 'São José de Princesa', 'São José do Bonfim', 'São José do Brejo do Cruz', 'São José do Sabugi', 'São José dos Cordeiros', 'São José dos Ramos', 'São João do Cariri', 'São João do Rio do Peixe', 'São João do Tigre', 'São Mamede', 'São Miguel de Taipu', 'São Sebastião de Lagoa de Roça', 'São Sebastião do Umbuzeiro', 'São Vicente do Seridó', 'Tacima', 'Taperoá', 'Tavares', 'Teixeira', 'Tenório', 'Triunfo', 'Uiraúna', 'Umbuzeiro', 'Vieirópolis', 'Vista Serrana', 'Várzea', 'Zabelê', 'Água Branca'],
  MS: ['Alcinópolis', 'Amambai', 'Anastácio', 'Anaurilândia', 'Angélica', 'Antônio João', 'Aparecida do Taboado', 'Aquidauana', 'Aral Moreira', 'Bandeirantes', 'Bataguassu', 'Batayporã', 'Bela Vista', 'Bodoquena', 'Bonito', 'Brasilândia', 'Caarapó', 'Camapuã', 'Campo Grande', 'Caracol', 'Cassilândia', 'Chapadão do Sul', 'Corguinho', 'Coronel Sapucaia', 'Corumbá', 'Costa Rica', 'Coxim', 'Deodápolis', 'Dois Irmãos do Buriti', 'Douradina', 'Dourados', 'Eldorado', 'Figueirão', 'Fátima do Sul', 'Glória de Dourados', 'Guia Lopes da Laguna', 'Iguatemi', 'Inocência', 'Itaporã', 'Itaquiraí', 'Ivinhema', 'Japorã', 'Jaraguari', 'Jardim', 'Jateí', 'Juti', 'Ladário', 'Laguna Carapã', 'Maracaju', 'Miranda', 'Mundo Novo', 'Naviraí', 'Nioaque', 'Nova Alvorada do Sul', 'Nova Andradina', 'Novo Horizonte do Sul', 'Paranaíba', 'Paranhos', 'Paraíso das Águas', 'Pedro Gomes', 'Ponta Porã', 'Porto Murtinho', 'Ribas do Rio Pardo', 'Rio Brilhante', 'Rio Negro', 'Rio Verde de Mato Grosso', 'Rochedo', 'Santa Rita do Pardo', 'Selvíria', 'Sete Quedas', 'Sidrolândia', 'Sonora', 'São Gabriel do Oeste', 'Tacuru', 'Taquarussu', 'Terenos', 'Três Lagoas', 'Vicentina', 'Água Clara'],
  RO: ["Alta Floresta D'Oeste", 'Alto Alegre dos Parecis', 'Alto Paraíso', "Alvorada D'Oeste", 'Ariquemes', 'Buritis', 'Cabixi', 'Cacaulândia', 'Cacoal', 'Campo Novo de Rondônia', 'Candeias do Jamari', 'Castanheiras', 'Cerejeiras', 'Chupinguaia', 'Colorado do Oeste', 'Corumbiara', 'Costa Marques', 'Cujubim', "Espigão D'Oeste", 'Governador Jorge Teixeira', 'Guajará-Mirim', 'Itapuã do Oeste', 'Jaru', 'Ji-Paraná', "Machadinho D'Oeste", 'Ministro Andreazza', 'Mirante da Serra', 'Monte Negro', "Nova Brasilândia D'Oeste", 'Nova Mamoré', 'Nova União', 'Novo Horizonte do Oeste', 'Ouro Preto do Oeste', 'Parecis', 'Pimenta Bueno', 'Pimenteiras do Oeste', 'Porto Velho', 'Presidente Médici', 'Primavera de Rondônia', 'Rio Crespo', 'Rolim de Moura', "Santa Luzia D'Oeste", 'Seringueiras', "São Felipe D'Oeste", 'São Francisco do Guaporé', 'São Miguel do Guaporé', 'Teixeirópolis', 'Theobroma', 'Urupá', 'Vale do Anari', 'Vale do Paraíso', 'Vilhena'],
  RR: ['Alto Alegre', 'Amajari', 'Boa Vista', 'Bonfim', 'Cantá', 'Caracaraí', 'Caroebe', 'Iracema', 'Mucajaí', 'Normandia', 'Pacaraima', 'Rorainópolis', 'São João da Baliza', 'São Luiz', 'Uiramutã'],
  AM: ['Alvarães', 'Amaturá', 'Anamã', 'Anori', 'Apuí', 'Atalaia do Norte', 'Autazes', 'Barcelos', 'Barreirinha', 'Benjamin Constant', 'Beruri', 'Boa Vista do Ramos', 'Boca do Acre', 'Borba', 'Caapiranga', 'Canutama', 'Carauari', 'Careiro', 'Careiro da Várzea', 'Coari', 'Codajás', 'Eirunepé', 'Envira', 'Fonte Boa', 'Guajará', 'Humaitá', 'Ipixuna', 'Iranduba', 'Itacoatiara', 'Itamarati', 'Itapiranga', 'Japurá', 'Juruá', 'Jutaí', 'Lábrea', 'Manacapuru', 'Manaquiri', 'Manaus', 'Manicoré', 'Maraã', 'Maués', 'Nhamundá', 'Nova Olinda do Norte', 'Novo Airão', 'Novo Aripuanã', 'Parintins', 'Pauini', 'Presidente Figueiredo', 'Rio Preto da Eva', 'Santa Isabel do Rio Negro', 'Santo Antônio do Içá', 'Silves', 'São Gabriel da Cachoeira', 'São Paulo de Olivença', 'São Sebastião do Uatumã', 'Tabatinga', 'Tapauá', 'Tefé', 'Tonantins', 'Uarini', 'Urucará', 'Urucurituba'],
  AP: ['Amapá', 'Calçoene', 'Cutias', 'Ferreira Gomes', 'Itaubal', 'Laranjal do Jari', 'Macapá', 'Mazagão', 'Oiapoque', 'Pedra Branca do Amapari', 'Porto Grande', 'Pracuúba', 'Santana', 'Serra do Navio', 'Tartarugalzinho', 'Vitória do Jari'],
  SE: ['Amparo do São Francisco', 'Aquidabã', 'Aracaju', 'Arauá', 'Areia Branca', 'Barra dos Coqueiros', 'Boquim', 'Brejo Grande', 'Campo do Brito', 'Canhoba', 'Canindé de São Francisco', 'Capela', 'Carira', 'Carmópolis', 'Cedro de São João', 'Cristinápolis', 'Cumbe', 'Divina Pastora', 'Estância', 'Feira Nova', 'Frei Paulo', 'Gararu', 'General Maynard', 'Gracho Cardoso', 'Ilha das Flores', 'Indiaroba', 'Itabaiana', 'Itabaianinha', 'Itabi', "Itaporanga d'Ajuda", 'Japaratuba', 'Japoatã', 'Lagarto', 'Laranjeiras', 'Macambira', 'Malhada dos Bois', 'Malhador', 'Maruim', 'Moita Bonita', 'Monte Alegre de Sergipe', 'Muribeca', 'Neópolis', 'Nossa Senhora Aparecida', 'Nossa Senhora da Glória', 'Nossa Senhora das Dores', 'Nossa Senhora de Lourdes', 'Nossa Senhora do Socorro', 'Pacatuba', 'Pedra Mole', 'Pedrinhas', 'Pinhão', 'Pirambu', 'Porto da Folha', 'Poço Redondo', 'Poço Verde', 'Propriá', 'Riachuelo', 'Riachão do Dantas', 'Ribeirópolis', 'Rosário do Catete', 'Salgado', 'Santa Luzia do Itanhy', 'Santa Rosa de Lima', 'Santana do São Francisco', 'Santo Amaro das Brotas', 'Simão Dias', 'Siriri', 'São Cristóvão', 'São Domingos', 'São Francisco', 'São Miguel do Aleixo', 'Telha', 'Tobias Barreto', 'Tomar do Geru', 'Umbaúba'],
  AL: ['Anadia', 'Arapiraca', 'Atalaia', 'Barra de Santo Antônio', 'Barra de São Miguel', 'Batalha', 'Belo Monte', 'Belém', 'Boca da Mata', 'Branquinha', 'Cacimbinhas', 'Cajueiro', 'Campestre', 'Campo Alegre', 'Campo Grande', 'Canapi', 'Capela', 'Carneiros', 'Chã Preta', 'Coité do Nóia', 'Colônia Leopoldina', 'Coqueiro Seco', 'Coruripe', 'Craíbas', 'Delmiro Gouveia', 'Dois Riachos', 'Estrela de Alagoas', 'Feira Grande', 'Feliz Deserto', 'Flexeiras', 'Girau do Ponciano', 'Ibateguara', 'Igaci', 'Igreja Nova', 'Inhapi', 'Jacaré dos Homens', 'Jacuípe', 'Japaratinga', 'Jaramataia', 'Jequiá da Praia', 'Joaquim Gomes', 'Jundiá', 'Junqueiro', 'Lagoa da Canoa', 'Limoeiro de Anadia', 'Maceió', 'Major Isidoro', 'Mar Vermelho', 'Maragogi', 'Maravilha', 'Marechal Deodoro', 'Maribondo', 'Mata Grande', 'Matriz de Camaragibe', 'Messias', 'Minador do Negrão', 'Monteirópolis', 'Murici', 'Novo Lino', "Olho d'Água Grande", "Olho d'Água das Flores", "Olho d'Água do Casado", 'Olivença', 'Ouro Branco', 'Palestina', 'Palmeira dos Índios', 'Pariconha', 'Paripueira', 'Passo de Camaragibe', 'Paulo Jacinto', 'Penedo', 'Piaçabuçu', 'Pilar', 'Pindoba', 'Piranhas', 'Porto Calvo', 'Porto Real do Colégio', 'Porto de Pedras', 'Poço das Trincheiras', 'Pão de Açúcar', 'Quebrangulo', 'Rio Largo', 'Roteiro', 'Santa Luzia do Norte', 'Santana do Ipanema', 'Santana do Mundaú', 'Satuba', 'Senador Rui Palmeira', 'São Brás', 'São José da Laje', 'São José da Tapera', 'São Luís do Quitunde', 'São Miguel dos Campos', 'São Miguel dos Milagres', 'São Sebastião', "Tanque d'Arca", 'Taquarana', 'Teotônio Vilela', 'Traipu', 'União dos Palmares', 'Viçosa', 'Água Branca'],
  RJ: ['Angra dos Reis', 'Aperibé', 'Araruama', 'Areal', 'Armação dos Búzios', 'Arraial do Cabo', 'Barra Mansa', 'Barra do Piraí', 'Belford Roxo', 'Bom Jardim', 'Bom Jesus do Itabapoana', 'Cabo Frio', 'Cachoeiras de Macacu', 'Cambuci', 'Campos dos Goytacazes', 'Cantagalo', 'Carapebus', 'Cardoso Moreira', 'Carmo', 'Casimiro de Abreu', 'Comendador Levy Gasparian', 'Conceição de Macabu', 'Cordeiro', 'Duas Barras', 'Duque de Caxias', 'Engenheiro Paulo de Frontin', 'Guapimirim', 'Iguaba Grande', 'Itaboraí', 'Itaguaí', 'Italva', 'Itaocara', 'Itaperuna', 'Itatiaia', 'Japeri', 'Laje do Muriaé', 'Macaé', 'Macuco', 'Magé', 'Mangaratiba', 'Maricá', 'Mendes', 'Mesquita', 'Miguel Pereira', 'Miracema', 'Natividade', 'Nilópolis', 'Niterói', 'Nova Friburgo', 'Nova Iguaçu', 'Paracambi', 'Paraty', 'Paraíba do Sul', 'Paty do Alferes', 'Petrópolis', 'Pinheiral', 'Piraí', 'Porciúncula', 'Porto Real', 'Quatis', 'Queimados', 'Quissamã', 'Resende', 'Rio Bonito', 'Rio Claro', 'Rio das Flores', 'Rio das Ostras', 'Rio de Janeiro', 'Santa Maria Madalena', 'Santo Antônio de Pádua', 'Sapucaia', 'Saquarema', 'Seropédica', 'Silva Jardim', 'Sumidouro', 'São Fidélis', 'São Francisco de Itabapoana', 'São Gonçalo', 'São José de Ubá', 'São José do Vale do Rio Preto', 'São João da Barra', 'São João de Meriti', 'São Pedro da Aldeia', 'São Sebastião do Alto', 'Tanguá', 'Teresópolis', 'Trajano de Moraes', 'Três Rios', 'Valença', 'Varre-Sai', 'Vassouras', 'Volta Redonda'],
  DF: ['Brasília']
};

var sortAlphabetically = function sortAlphabetically(cityA, cityB) {
  return cityA.localeCompare(cityB);
};

function getCities(state) {
  if (state) {
    var states = getStates();
    var foundState = states.find(function (_ref) {
      var name = _ref.name,
          code = _ref.code;
      return name === state || code === state;
    });

    if (!foundState) {
      return [];
    }

    return CITIES_DATA[foundState.code].sort(sortAlphabetically);
  }

  return Object.values(CITIES_DATA).reduce(function (acc, city) {
    return acc.concat(city);
  }, []).sort(sortAlphabetically);
}

export { capitalize, format$2 as formatBoleto, format$1 as formatCEP, format$5 as formatCNPJ, format$4 as formatCPF, format$3 as formatCurrency, format as formatPJ, generate$1 as generateCNPJ, generate as generateCPF, generateChecksum, generateRandomNumber, getCities, getStates, isLastChar, isValid$6 as isValidBoleto, isValid$5 as isValidCEP, isValid$8 as isValidCNPJ, isValid$7 as isValidCPF, isValid$3 as isValidEmail, isValid as isValidIE, isValidLandlinePhone, isValid$4 as isValidLicensePlate, isValidMobilePhone, isValid$1 as isValidPIS, isValid$2 as isValidPhone, onlyNumbers, parse$1 as parseCurrency };
//# sourceMappingURL=brazilian-utils.esm.js.map
